export default {
        vi: {
                period: "Hiệu lực",
                cancelledDate: "Ngày hủy",
                registerNew: "Đăng ký mới",
                renew: "Gia hạn",
                changeInfo: "Thay đổi thông tin",
                performedBy: "Thực hiện bởi",
                add: "Thêm",
                accessCode: "Mã truy cập",
                accessLink: "Link truy cập",
                accessCodeFormFeedback: "Độ dài 6-12 ký tự, chỉ dùng số hoặc chữ không dấu",
                AccessCodeIsRequired: "Mã truy cập bắt buộc",
                AccessCodeLength: "Mã truy cập tối thiểu 6 ký tự và tối đa 12 ký tự",
                AccessCodeRequired: "AccessCode là bắt buộc ",
                AccessIsDenied: "Truy cập dữ liệu không hợp lệ",
                accessPermission: "Quyền truy cập",
                account: "Tài khoản",
                accountId: "ID tài khoản",
                accountInfo: "Thông tin tài khoản",
                accountsSignDay: "Tài khoản ký hợp đồng trong ngày",
                action: "Hoạt động",
                actionComplete: "Hoàn tất",
                actionDelete: "Xoá",
                activate: "Kích hoạt",
                activateBackupSchedule: "Kích hoạt lịch sao lưu",
                ActivationCodeExpired: "Mã kích hoạt tài khoản đã hết hiệu lực",
                active: "Hoạt động",
                activeStatus: "Kích hoạt",
                activeSubPlans: "Đang sử dụng",
                activeSuccessful: "Kích hoạt thành công",
                addIpBlock: "Thêm IP chặn",
                addMeetingParticipant: "Thêm một dòng",
                addMeetingParticipantSuccessful: "Thêm người tham gia thành công",
                addNewContact: "Thêm liên hệ mới",
                address: "Địa chỉ",
                AddressMaxLength: "Địa chỉ tối đa 255 ký tự",
                adminAccountList: "Danh sách tài khoản quản trị",
                adminSearchPlaceholder: "Tìm theo tên, email, SĐT",
                appNameSearchPlaceholder: "Tìm theo tên ứng dụng, domain",
                advancefilter: "Lọc nâng cao",
                agree: "Đồng ý",
                alert: "Thông báo",
                all: "Tất cả",
                alreadyHaveAccountQ: "Đã có tài khoản?",
                alreadySentEmailInvitation: "Đã gửi email mời tham gia",
                alreadySentMeetingCancelEmail: "Đã gửi email báo huỷ lịch họp",
                alreadySentMeetingUpdateEmail: "Đã gửi email thay đổi lịch họp",
                amountCustomerToPay: "Số tiền khách cần trả",
                and: "và",
                ApiKeyNameyIsNull: "ApiKey và ApiKeyName là bắt buộc",
                APIURLContactImport: "API danh bạ:",
                ApiUrlRequired: "API danh bạ là bắt buộc",
                AppActiveRequired: "Trạng thái là bắt buộc",
                AppDomainNameRequired: "Tên domain là bắt buộc ",
                application: "Ứng dụng",
                appList: "Danh sách ứng dụng",
                AppLogoExtRequired: "Loại file là bắt buộc",
                AppLogoRequired: "Logo là bắt buộc ",
                apply: "Áp dụng",
                appName: "Tên ứng dụng",
                AppNameCustomerExist: "Khách hàng đã được chọn để tạo ứng dụng",
                AppNameNotFound: "Không tìm thấy ứng dụng",
                AppNameRequired: "Tên ứng dụng là bắt buộc",
                areaFilterSelectLabel: "KH thuộc TTKD",
                AreaIdIsRequired: "ID Tỉnh Thành bắt buộc ",
                AreaRequired: "Khu vực là bắt buộc nhập",
                attribute: "Thuộc tính",
                backup1: "Sao lưu dự phòng",
                backupCronSchedule: "Lịch sao lưu",
                backupDb: "Sao lưu csdl",
                backupLocalPath: "Đường dẫn sao lưu",
                backupOptions: "Tùy chọn lưu trữ",
                BackupPolicyBadRequest: "Lịch sao lưu không hợp lệ. Cú pháp: giây phút giờ ngày tháng năm. Ví dụ: 5 1 9 4 *  ?",
                backupSourceCode: "Sao lưu mã nguồn",
                BadRequest: "Có lỗi xảy ra",
                browser: "Trình duyệt",
                business: "Doanh nghiệp",
                cacgoicuoccuakhuvuc: "Các gói cước của khu vực",
                calendar: "Lịch tuần",
                calendarLocationName: "Tên địa điểm",
                cancel: "Hủy bỏ",
                cancelled: "Đã hủy",
                cancelMeeting: "Huỷ cuộc họp",
                cancelMeetingSuccessful: "Huỷ cuộc họp thành công",
                cancelService: "Hủy dịch vụ",
                cancelServiceConfirm: "Bạn có chắc muốn hủy dịch vụ?",
                cancelServiceSuccess: "Hủy dịch vụ thành công",
                cancelThisMeetingConfirm: "Bạn có chắc chắn muốn huỷ cuộc họp này?",
                cannotLeaveFieldBlank: "Không được bỏ trống trường này",
                cannotGetDownloadLink: "Lỗi phát sinh! Không lấy được nội dung ghi hình",
                downloadLinkExpired: "Liên kết tải xuống đã hết hạn",
                capNhatKhuVuc: "Cập nhật khu vực",
                chairman: "Chủ trì",
                change: "Thay đổi",
                changePassword: "Đổi mật khẩu",
                changeWebPort: "Đổi port website",
                chartLogTitle: "Thống kê cảnh báo trên thiết bị và trình duyệt",
                chartSub1: "Thiết bị",
                chartSub2: "Nền tảng PC",
                chartSub3: "Trình duyệt Web",
                chartSub4: "Nền tảng Mobile",
                chartView: "Biểu đồ",
                chonGoiCuoc: "Chọn gói cước",
                chooseContact: "Chọn liên hệ",
                faceid_not_verified: "Người dùng này chưa có faceID hoặc faceID chưa được xác thực",
                chooseFromContacts: "Chọn từ danh bạ",
                chooseSubscription: "Chọn gói cước",
                expiredServce: "Dịch vụ của quý khách đã hết hạn. Vui lòng liên hệ để gia hạn hoặc đăng ký dịch vụ mới.",
                chuadangkygoicuoc: "Chưa đăng ký gói cước",
                clearFilter: "Xóa lọc",
                clone: "Nhân bản",
                close: "Đóng",
                companyName: "Tên công ty",
                configBackupPolicy: "Thiết lập sao lưu dự phòng",
                ConfigBackupPolicyInvalid: "Thông tin cấu hình sao lưu không hợp lệ",
                ConfigFtpHostInvalid: "Thông tin cấu hình FTP không hợp lệ",
                ConfigIsActive: "Phải inactive cấu hình trước khi xoá",
                configPasswordPolicy: "Cài đặt chính sách mật khẩu",
                confirmPassword: "Xác nhận mật khẩu",
                ConfirmPasswordRequired: "Vui lòng nhập xác nhận mật khẩu",
                contact: "Danh bạ",
                contactFileFormatError: "Vui lòng tải lên file có định dạng excel và cấu trúc bảng giống file mẫu",
                contactFileSizeError: "Không thể gửi tệp có kích thước lớn hơn 1MB",
                contactList: "Danh sách liên lạc",
                ContactNameIsRequired: "Họ Tên là bắt buộc",
                ContactNameMaxLength: "Độ dài Họ Tên tối đa 255 ký tự ",
                contactSearchPlaceholder: "Tìm theo tên, email, SĐT",
                content: "Nội dung",
                contentCannotBeBlank: "Nội dung không được bỏ trống",
                contentError: "Nội dung cảnh báo",
                ContentRequired: "Nội dung không được bỏ trống",
                copied: "Sao chép thành công",
                copiedHostJoinUrl: "Sao chép link chủ trì thành công",
                copieQRLink: "Sao chép link họp",
                copy: "Sao chép",
                copyLink: "Sao chép link",
                copyJoinUrl: "Sao chép link truy cập",
                coreDomain: "Hạ tầng",
                coreDomainSelect: "Chọn hạ tầng cuộc họp",
                coreImplName: "Nền tảng sử dụng",
                CoreImplNameIsRequired: "Sử dụng nền tảng/công nghệ : BBB/Zoom",
                corporation: "Tổng công ty",
                corporations: "Tổng công ty",
                count: "Số lượng",
                config: "Hạ tầng",
                enableDefault: "Bật mặc định",
                editFeature: "Chỉnh sửa chức năng",
                createFeature: "Tạo chức năng",
                setting: "Thiết lập",
                countPackage: "Và {count} gói cước",
                create: "Tạo",
                createAccount: "Tạo tài khoản",
                createAccountSuccessful: "Tạo tài khoản thành công",
                createAdminAccount: "Tạo tài khoản quản trị",
                createAdminAccountSuccessful: "Tạo tài khoản QTDV thành công",
                createApiConfigSuccessful: "Tạo hạ tầng thành công",
                createApp: "Tạo ứng dụng",
                createAppSuccessful: "Tạo ứng dụng thành công",
                createBy: "Người tạo",
                createCalendarLocationSuccessful: "Thêm địa điểm thành công",
                createCalendarMeeting: "Tạo lịch cuộc họp",
                createContactSuccessful: "Thêm liên lạc thành công",
                createContentWidget: "Đặt đoạn mã này ở bất cứ đâu mà bạn muốn thêm Widget vào",
                createCustomer: "Tạo khách hàng",
                createCustomerAdminAccount: "Tạo tài khoản quản trị phía khách hàng",
                createCustomerAdminAccountSuccessful: "Tạo tài khoản quản trị khách hàng thành công",
                createCustomerUserAccount: "Tạo tài khoản người dùng",
                createDate: "Ngày tạo",
                createdDate: "Ngày tạo",
                createdTime: "Ngày tạo",
                createEvent: "Tạo lịch",
                createIpPolicySuccessful: "Thêm mới thành công",
                createMeeting: "Tạo cuộc họp",
                createMeetingSuccessful: "Tạo cuộc họp thành công",
                createNew: "Tạo mới",
                createNewCustomer: "Tạo khách hàng mới",
                createNewCustomerSuccessful: "Tạo khách hàng mới thành công",
                createRandomAccessCode: "Tạo ngẫu nhiên",
                createRegionSuccessful: "Thêm mới khu vực thành công",
                createSaleAccount: "Tạo tài khoản TTKD T/TP",
                createSaleAccountSuccessful: "Tạo tài khoản TTKD T/TP thành công",
                createServiceAdminAccount: "Tạo tài khoản quản trị dịch vụ",
                createSubPlan: "Tạo gói cước",
                createSubPlanSuccessful: "Tạo gói cước thành công",
                errorNullSubcription: "Vui lòng chọn ít nhất một chức năng cho gói cước",
                createSuccessful: "Thêm mới thành công",
                createWidget: "Tạo Widget",
                creator: "Người tạo",
                cronScheduleExplain: "Định dạng: giây, phút, giờ, ngày, tháng, năm. Ví dụ: 0 1 1 * * ? (Sao lưu hàng ngày lúc 01:01:00)",
                currentExpDate: "Ngày hết hạn hiện tại",
                currentPassword: "Mật khẩu hiện tại",
                CusSubsPlanToRenewIsNotFound: "Không tìm thấy gói cước của khách hàng cần nâng cấp",
                customer: "Khách hàng",
                customerAdminAccount: "Tài khoản quản trị khách hàng",
                customerAdminAccountList: "Danh sách tài khoản quản trị khách hàng",
                customerAutofillPlaceholder: "tìm theo mã KH, tên, email hoặc SĐT",
                CustomerDuplicateCode: "Trùng mã khách hàng",
                CustomerDuplicateIdCode: "Trùng số giấy tờ",
                CustomerDuplicatePhoneNumber: "Trùng số điện thoại",
                CustomerDuplicateTaxCode: "Trùng mã số thuế",
                customerId: "Mã khách hàng",
                CustomerIdIsRequired: "ID Khách hàng bắt buộc nhập",
                customerIdShort: "Mã KH",
                customerInfo: "Thông tin khách hàng",
                CustomerIsExisting: "Khách hàng này đang tồn tại (Trùng Mã số thuế hoặc số của các loại giấy tờ khác)",
                customerList: "Danh sách khách hàng",
                customerName: "Tên khách hàng",
                CustomerNameIsRequired: "Họ Tên không được bỏ trống",
                CustomerNameMaxLength: "Độ dài Họ Tên tối đa 255 ký tự ",
                customerNameShort: "Tên KH",
                CustomerNotMatchForRenewOrUpgrade: "Khách hàng cần nâng cấp hoặc gia hạn không khớp với khách hàng đăng ký dịch vụ của gói cần nâng cấp hoặc gia hạn",
                customerSearchPlaceholder: "mã KH, tên, email hoặc SĐT",
                customerStatusActive: "Hoạt động",
                customerStatusCancelled: "Đã huỷ",
                customerStatusInactive: "Tạm ngưng",
                inActive: "Không hoạt động",
                CustomerSubscriptionIsExpired: "Gói dịch vụ của bạn đã hết hạn. Vui lòng gia hạn để tiếp tục sử dụng dịch vụ.",
                CustomerSubscriptionNotFound: "Bạn chưa đăng ký gói dịch vụ. Vui lòng đăng ký để sử dụng tính năng này.",
                customerType: "Loại khách hàng",
                customerSource: "Loại đối tượng",
                customerTypeBusiness: "Doanh nghiệp",
                customerTypePersonal: "Cá nhân",
                customerUserAccountList: "Danh sách tài khoản người dùng",
                currentPackage: "Bạn đang dùng gói {package}:",
                packageLimit: "Bạn có thể tổ chức cuộc họp tối đa {hour} với tối đa {person} người tham gia.",
                storageNotEnough: "Dung lượng còn lại của bạn là {storage}MB, để ghi lại cuộc họp cần ít nhất 200MB dung lượng trống. Hãy nâng cấp gói cước hoặc giải phóng dung lượng để sử dụng tính năng ghi hình.",
                danhSachGoiCuoc: "Danh sách gói cước",
                dashboardChartTitle: "TỔNG SỐ CUỘC HỌP, NGƯỜI THAM GIA & CAMERA BẬT",
                date: "Ngày",
                time: "Thời gian",
                datetime: "Thời gian họp",
                days: "Ngày",
                decree: "Nghị định",
                here: "tại đây",
                remainingDays: "Số ngày hiệu lực",
                defaultAccount: "Tài khoản mặc định",
                delete: "Xoá",
                deleteAccount: "Xóa tài khoản",
                deleteRecording: "Xóa ghi hình",
                deleteAccountConfirmation: 'Bạn có chắc chắn muốn xoá tài khoản "{account}"?',
                deleteAccountSuccess: "Xoá tài khoản thành công",
                deleteAll: "Xóa tất cả",
                deleteAllRecordings: "Xóa tất cả ghi hình",
                deleteAllData: "Xóa hết dữ liệu",
                deleteAllContactsConfirm: "Bạn có muốn xóa tất cả danh bạ",
                DeleteAllCustomerUserViewSuccessful: "Xoá thông tin tài khoản thành công",
                deleteAllViewer: "Xóa tất cả người xem",
                deleteAllViewerConfirmation: "Bạn có chắc chắn muốn xóa tất cả người xem ?",
                deleteAllViewerSuccess: "Xóa tất cả tài khoản người xem thành công",
                deleteBy: "Người xoá",
                deleteContactSuccessful: "Xoá liên hệ thành công",
                deleteRegionSuccessful: "Xóa khu vực thành công",
                deleteFunctionSuccessful: "Xóa chức năng thành công",
                deleteCustomer: "Xoá khách hàng",
                deleteCustomerConfirmation: 'Bạn có chắc chắn muốn xoá khách hàng "{name}"?',
                deleteCustomerSuccess: "Xoá khách hàng thành công",
                deleteDate: "Ngày xóa",
                deleteEventConfirm: `Bạn có chắc chắn muốn xoá lịch "{subject}"?`,
                deleteEventSuccessful: "Xoá lịch thành công",
                deleteIpBlockConfirm: "Bạn có chắc chắn muốn xoá? (ID: {id}, IP: {ip})?",
                deleteIpBlockSuccess: "Xoá IP thành công",
                deleteLogConfirm: "Bạn có chắc chắn muốn xoá? (ID: {id})",
                deleteLogSuccessful: "Xoá log thành công",
                deleteMeeting: "Xoá cuộc họp",
                deleteMeetingSuccessful: "Xoá cuộc họp thành công",
                deleteRecordedSuccessful: "Xóa ghi hình thành công",
                deleteRecordedSuccessfulAll: "Xóa tất cả ghi hình thành công",
                deleteRecordConfirmation2: `Bạn có chắc chắn muốn xoá "{name}"? (ID: {id})?`,
                deleteRecordConfirmation: "Bạn có chắc chắn muốn xoá {name}? (ID: {id})?",
                deleteSubPlanConfirm: "Bạn có chắc chắn muốn xoá gói cước {name} (ID: {id})?",
                deleteRegionConfirm: `Bạn có chắc chắn muốn xoá khu vực "{name}"? (Mã: {id})?`,
                deleteFunctionConfirm: `Bạn có chắc chắn muốn xoá chức năng "{name}"? (Mã: {id})?`,
                deleteSubPlanSuccessful: "Xoá gói cước thành công",
                deleteSuccessful: "Xoá thành công",
                deleteThisMeetingConfirm: "Bạn có chắc chắn muốn xoá cuộc họp này?",
                deleteThisRecordedConfirm: `Bạn có chắc muốn xóa ghi hình cuộc họp "{name}" ?`,
                deleteThisRecordedConfirmByType: `Bạn có chắc muốn xóa file "<b>{type}</b>" của  cuộc họp "{name}"?`,
                deleteAllRecordedConfirm: "Bạn có chắc muốn xóa tất cả ghi hình cuộc họp ?",
                deleteYourAccount: "Bạn có chắc chắn muốn xóa tài khoản của mình ?",
                demo: "Demo",
                description: "Mô tả",
                defaultTurnOn: "Mặc định luôn được bật sử dụng",
                deselectAll: "Bỏ chọn tất cả",
                details: "Chi tiết",
                device: "Thiết bị",
                disagree: "Không đồng ý",
                displayActiveSubConcurrentMeetings: "{count} CH đồng thời",
                displayActiveSubMaxMeetingLength: "{count} phút / CH",
                displayActiveSubMaxParticipants: "{count} người / CH",
                displayActiveSubMaxParticipantsPool: "Tối đa {count} người tham gia",
                displayActiveSubMeetingCount: "{count} CH / tháng",
                displayActiveSubPrice: "{price} VND / {months} tháng",
                displayStorageUsed: "Đã sử dụng {used}/{total} GB",
                displayQuotaUsedAndTotal: "Đã sử dụng {used}/{total} Phút",
                displayQuotaUsed: "Đã sử dụng {used} Phút",
                documentNumber: "Số giấy tờ",
                documentNumberInvalid: "Số giấy tờ không hợp lệ",
                documentType: "Loại giấy tờ",
                domain: "Tên miền",
                done: "Đã thực hiện",
                dontHaveAccount: "Chưa có tài khoản?",
                download: "Tải xuống",
                downloadApp: "Tải ứng dụng",
                downloadSampleFile: "Tải file mẫu",
                edit: "Sửa",
                editEvent: "Chỉnh sửa lịch",
                editInfo: "Sửa thông tin",
                editMeeting: "Chỉnh sửa cuộc họp",
                editRegion: "Cập nhật khu vực kinh doanh",
                effDate: "Ngày hiệu lực",
                emailContent: "Nội dung",
                EmailExist: "Địa chỉ email đã được sử dụng",
                EmailExist1: "Địa chỉ email đã được sử dụng",
                EmailInvalid: "Địa chỉ Email không hợp lệ",
                EmailMaxLength: "Email tối đa 250 ký tự",
                emailPlaceHolder: "Email",
                EmailRequired: "Email là bắt buộc",
                emailSubject: "Tiêu đề",
                emailTemplate: "Mẫu email",
                emailTypeCancelMeeting: "Huỷ lịch họp",
                emailTypeInviteMeeting: "Mời tham gia",
                emailTypeUpdateMeeting: "Thay đổi lịch họp",
                enableAutomaticMeetingRecording: "Tự động bật ghi âm cuộc họp",
                enableMicro: "Cho phép sử dụng Micro",
                enableParticipationBeforeHost: "Cho phép tham gia trước người chủ trì",
                enableTakingNote: "Bật tính năng ghi chú",
                enableToggleMeetingRecording: "Cho phép bật/tắt ghi âm cuộc họp",
                enableVoiceText: "Sử dụng chức năng tóm tắt cuộc họp",
                enableAutoVoiceText: "Tự động bật chức năng tóm tắt cuộc họp",
                endDate: "Ngày kết thúc",
                endMeeting: "Kết thúc",
                endMeetingWarning: "Kết thúc cuộc họp {name} (ID: {id})?",
                endThisMeetingWarning: "Kết thúc cuộc họp này?",
                enterAccessCode: "Mã truy cập",
                enterprise: "Doanh nghiệp",
                featureConfig: "Cấu hình chức năng",
                enterInfrastructureID: "Nhập vào ID của hạ tầng",
                errorRow: "Lỗi dòng {row}, '{value}' không hợp lệ",
                errorStat: "Thống kê cảnh báo",
                eventAllDay: "Xảy ra cả ngày",
                eventEndTime: "Giờ kết thúc",
                eventInvitees: "Mời",
                eventParticipants: "Thành phần",
                eventPreparation: "Chuẩn bị",
                eventStartTime: "Giờ bắt đầu",
                eventStatusCancelled: "Đã huỷ",
                eventStatusPending: "Chưa được duyệt",
                evict: "Thu hồi",
                expDate: "Ngày hết hạn",
                expDateAfterRenew: "Ngày hết hạn sau khi gia hạn",
                expired: "Đã hết hạn",
                expireDate: "Ngày hết hạn",
                expireYourPackage: "Gói cước của bạn đã hết hạn",
                export: "Xuất Excel",
                contentMeeting: "Nội dung cuộc họp",
                aiSummaryDisclaimer: "Nội dung được tổng hợp từ AI có thể chưa đầy đủ hoặc có sai sót. Vui lòng kiểm tra lại nội dung phiên họp để đảm bảo tính chính xác!",
                exportContent: "Xuất nội dung",
                generalContent: "Biên bản họp",
                summaryOfSTT: "Tóm tắt STT",
                summaryOfTimeline: "Tóm tắt Timeline",
                exportLog: "Xuất log",
                exportParticipants: "Xuất người tham gia",
                exportSumary: "Xuất tóm tắt",
                faceChosePlaceholder: "Có thể chọn nhiều ảnh cùng lúc",
                faceIdIconSub: "Đã có hình ảnh nhận diện khuôn mặt",
                featureList: "Danh sách chức năng",
                featureCode: "Mã chức năng",
                featureName: "Tên chức năng",
                faceidStatus: "Bật/tắt FaceID",
                faceIdSub: "Chỉ những người có thông tin hình ảnh khuôn mặt mới được thêm vào cuộc họp",
                faceImage: "Hình ảnh khuôn mặt",
                faceImageTitle1: "Chọn các hình ảnh cho người dùng",
                faceImageTitle2: "Tên hình giống với code tương ứng của người dùng trong danh bạ",
                file_not_found: "Không tìm thấy tập tin ",
                footerAttribution: "Sản phẩm của VNPT-IT",
                forgotPassword: "Cấp mật khẩu mới",
                forgotPasswordQMark: "Quên mật khẩu?",
                FormatEmailInvalid: "Email không đúng định dạng",
                FormatInvalidName: "Tên không được để trống hoặc có các ký tự `!@#$%^&*~{}?",
                FormatPhoneInvalid: "Số điện thoại không đúng định dạng",
                from: "Từ",
                fromDate: "Từ ngày",
                khoangthoigian: "Khoảng thời gian",
                fullName: "Họ và tên",
                FullNameRequired: "Họ tên là bắt buộc",
                gmTokenConfig: "Kích hoạt token tích hợp",
                guideToken: "Xem hướng dẫn tích hợp Token",
                headerMenuAdmin: "Quản trị",
                hintUsernameOrEmail: "Tên đăng nhập, email",
                hostJoinUrl: "Quản trị viên/Điều hành",
                hours: "giờ",
                with: "với",
                IdRequired: "Id là bắt buộc",
                importContactFromFile: "Nhập danh bạ",
                importContactOption0: "Nhập từ file",
                importContactOption1: "Nhập từ API liên kết",
                importContactOption: "Hình thức:",
                importContactsFromFileSuccessful: "Nhập dữ liệu thành công",
                ImportContactSuccessful: "Import danh bạ thành công",
                vuilongchonFileImport: "Vui lòng chọn file để import",
                importFromFile: "Nhập từ file",
                importUserFromFile: "Nhập tài khoản người dùng từ file",
                inactiveSubPlans: "Đã vô hiệu hoá",
                incorrect_file_format: "Không đúng định dạng file",
                includespacename: "Tên đăng nhập không được chứa khoảng trắng hoặc ký tự đặc biệt",
                specailRegex: "không được phép chứa ký tự đặc biệt hoặc khoảng trắng",
                recheck: "vui lòng kiểm tai lại",
                recheckExcel: "Xin vui lòng kiểm tra lại dữ liệu trong file excel: ",
                duplicateusername: "Dữ liệu username trùng: ",
                duplicateemail: "Dữ liệu email trùng:",
                at: "tại",
                row: "dòng",
                uploadokbut: "Dữ liệu import có lỗi:",
                recheckfile: "Vui lòng kiểm tra lại dữ liệu trong file và thao tác lại!",
                includespaceemail: "Thông tin email không được chứa khoảng trắng",
                individual: "Cá nhân",
                inprogress: "Đang diễn ra",
                InternalServerError: "Có lỗi xảy ra trong quá trình thực hiện",
                InvalidAccessCode: "Mã truy cập không đúng",
                InvalidActivationCode: "Mã kích hoạt tài khoản không hợp lệ",
                InvalidAreaId: "Khu vực không hợp lệ",
                InvalidCas: "Thông tin truy cập không hợp lệ",
                InvalidContactCode: "Mã Code NULL hoặc không hợp lệ",
                InvalidContactId: "Không tìm thấy thông tin danh bạ",
                InvalidCustomer: "Khách hàng không hợp lệ hoặc không tồn tại",
                InvalidCustomerId: "Không tìm thấy Khách hàng",
                InvalidCustomerName: "Họ và tên khách hàng không hợp lệ, Họ và tên chỉ chứa các ký tự alphabet",
                InvalidCustomerSubscriptionId: "Không tìm thấy thông tin của khách hàng đăng ký gói cước",
                invalidDateRange: "Khoảng thời gian đã chọn không hợp lệ",
                invalidEmail: "Email không hợp lệ",
                InvalidIPAddress: "Không đúng cấu hình IP ",
                InvalidLogin: "Tên đăng nhập hoặc mật khẩu không đúng",
                InvalidLogo: "Ảnh Logo không hợp lệ. Chỉ cho phép ảnh có định dạng .jpg, .jpeg, .png",
                invalidMeetingDurationOrExceededLimit: "Thời lượng cuộc họp không hợp lệ hoặc vượt quá giới hạn cho phép",
                InvalidMeetingId: "Không tìm thấy cuộc họp",
                invalidMeetingOperatorOrParticipantEmail: "Email người điều hành hoặc người tham dự không hợp lệ",
                InvalidMeetingRole: "Vai trò người tham gia cuộc họp không hợp lệ. Vai trò gồm : tham gia (PARTICIPANT), người điều hành (OPERATOR)",
                invalidMeetingStartDatetime: "Thời điểm diễn ra cuộc họp phải lớn hơn thời gian hiện tại!",
                InvalidMeetingStatus: "Trạng thái cuộc họp không hợp lệ. Trạng thái cuộc hợp gồm : Chờ (pending), Đang thực hiện (inprogress), Kết thúc (end)",
                InvalidParamInput: "Dữ liệu đầu vào bị NULL hoặc không hợp lệ",
                InvalidParticipantName: "Lỗi: Tên người tham dự không đúng cú pháp",
                invalidPasswordPattern: "Biểu thức xác thực mật khẩu không đúng",
                invalidPhoneFormat: "Số điện thoại không đúng định dạng",
                InvalidRequest: "Yêu cầu không hợp lệ",
                InvalidSecretKey: "Mã bí mật không hợp lệ",
                invalidSecretKey: "Mã bí mật không hợp lệ, vui lòng thử lại.",
                InvalidSubscriptionPlan: "Gói cước không hợp lệ hoặc không tồn tại",
                invalidTaxCode: "Mã số thuế không hợp lệ",
                InvalidWebhookConfigureId: "WebhookConfigureId không hợp lệ",
                invnpt: "Trong VNPT",
                IPAddressIsRequired: "Địa chỉ Ip là bắt buộc",
                IPAddressNULL: "Địa chỉ IP không được null",
                ipBlacklist: "Danh sách chặn IP",
                ipBlockList: "Danh sách chặn IP",
                issueDate: "Ngày cấp",
                issuePlace: "Nơi cấp",
                it: "IT",
                itemsPerPage: "dòng / trang",
                joinByFaceId: "Tham gia bằng nhận diện khuôn mặt",
                joinMeeting: "Tham gia",
                joinMeetingBrowser: "Tham gia",
                inputInfoMeeting: "Nhập thông tin cuộc họp",
                joinMeetingDesc: "Nhập thông tin để tham gia vào cuộc họp của bạn",
                joinCode: "Mã tham gia",
                joinCodePlaceHolder: "Mã tham gia (VD: 123456789)",
                joinWithAnotherCode: "Tham gia cuộc họp khác",
                joinMeetingOperator: "Bạn đang tham gia quyền",
                joinMeetingApp: "Mở ứng dụng",
                keyword: "Từ khoá",
                keywordMeetings: "Tìm theo ID, tên cuộc họp",
                khongxacdinh: "Lỗi không xác định",
                lastUpdate: "Cập nhật lần cuối",
                leaveMeeting: "Rời khỏi",
                linksAndAccessCodes: "Thông tin tham gia",
                loadingData: "Đang tải dữ liệu...",
                LocalPathInvalid: "Đường dẫn sao lưu không hợp lệ.",
                LocalPathIsRequired: "Đường dẫn lưu trữ không được để trống",
                location: "Địa điểm",
                LockedOutDuration: "Thời gian khoá tài khoản trong khoảng 1 - 1440 phút",
                login: "Đăng nhập",
                LoginLockoutEnabled: "Tài khoản sẽ tạm khoá {m} phút sau {i} lần đăng nhập thất bại.",
                loginPageTitle: "Đăng nhập",
                loginSME: "Đăng nhập bằng IDP",
                loginVnptSso: "VNPT SSO",
                logout: "Đăng xuất",
                logPolicy: "Chính sách log",
                maKhuVuc: "Mã khu vực",
                manageFunction: "Quản lý chức năng",
                manageAccount: "Quản lý tài khoản",
                manageConfigToken: "Quản lý cấu hình",
                configurations: "cấu hình",
                manageConfigulation: "Quản lý hạ tầng",
                manageGMToken: "Quản lý Token",
                manageGMTokenTitle: "Danh sách tokens",
                manageMeetings: "Quản lý cuộc họp",
                sourceMeetingTooltip: "Phiên gốc: {id}",
                manageServices: "Quản lý dịch vụ",
                manageStorage: "Quản lý lưu trữ",
                freeStorage: "còn trống {storage} GB",
                freeQuota: "còn trống {remaining} phút",
                manageRecordings: "Quản lý Ghi hình",
                maximum: "Tối đa",
                maximumLengthOfOneMeeting: "Thời lượng cuộc họp",
                MaximumLengthOfOneMeetingIsRequired: "Thời lượng tối đa 1 buổi họp là bắt buộc",
                MaximumLengthOfOneMeetingLength: "Thời lượng tối đa từ 30 - 1440",
                maximumNumberOfParticipantsInMeeting: "Số người trong cuộc họp",
                managementType: "Kiểu quản lý",
                concurrentParticipantPoolOption: "Pool người tham dự",
                maxParticipantPoolRequired: "Tổng số người tham dự đồng thời là bắt buộc",
                participantsCountExceededLimit: "Số người tham dự tối đa vượt quá giới hạn cho phép ({max})",
                MaximumNumberOfParticipantsIsRequired: "Số người tối đa tham gia một buổi họp là bắt buộc",
                MaximumNumberOfParticipantsLengh: "Số người tối đa tham gia từ 1: 1000",
                maxMeetingParticipantsExceeded: "Vượt quá số người tham dự tối đa!",
                limitExceededTitle: "Vượt quá giới hạn gói cước!",
                poolLimitExceededDesc: "Tổng số người tham dự hiện tại đã vượt giới hạn gói cước <strong>({total}/{limit} người)</strong>. Vui lòng giảm số lượng người tham gia hoặc kết thúc các cuộc họp khác đang diễn ra.",
                createMeetingCoreFailedTitle: "Khởi tạo cuộc họp thất bại!",
                tokenInvalidTitle: "Phiên làm việc không hợp lệ!",
                forbiddenTitle: "Không có quyền truy cập!",
                internalServerErrorTitle: "Không thể xử lý yêu cầu!",
                meetingNotFoundTitle: "Không tìm thấy cuộc họp!",
                customerSubscriptionIsExpiredTitle: "Hết hạn gói cước!",
                whiteboardInUseByOtherMeetingTitle: "Bảng trắng đang được sử dụng!",
                lockTimeoutTitle: "Yêu cầu quá hạn!",
                errorCodeLabel: "Mã lỗi",
                meetingStatusNotPendingOrEndTitle: "Trạng thái không hợp lệ!",
                customerSubscriptionNotFoundTitle: "Không có dịch vụ!",
                notFoundPlanInCustomerSubscriptionTitle: "Gói cước không hợp lệ!",
                maxParticipant: "SL tham dự lớn nhất",
                media: "Media",
                meeting: "Cuộc họp",
                MeetingAccessDenied: "Bạn không có quyền thao tác phiên họp này",
                meetingActualTime: "Thời gian thực tế",
                meetingChatNotAllow: "Không cho phép trò chuyện",
                meetingRecordingDeleted: "Cuộc họp đã xóa ghi hình",
                recodingDeleted: "Đã xóa ghi hình",
                meetingConfig: "Thiết lập cuộc họp",
                meetingCount: "Số lượng phiên họp",
                MeetingCountDailyIsExceeded: "Cuộc họp hiện tại vượt quá số lượng cho phép của gói đăng ký",
                meetingCountDetails: "Chi tiết số lượng phiên họp",
                meetingCountTotal: "Tổng số lượng phiên họp",
                meetingDate: "Ngày họp",
                meetingDetailReport: "Báo cáo chi tiết cuộc họp",
                meetingDetailReportSearchPlaceholder: "Tìm theo tên cuộc họp, người tạo",
                meetingDetails: "Chi tiết cuộc họp",
                meetingDuration: "Thời lượng",
                meetingDurationFormFeedback: "Thời lượng tối thiểu 15 phút, tối đa",
                meetingEndedMsg: "Cuộc họp đã kết thúc",
                meetingHasRecording: "Cuộc họp được ghi hình",
                meetingId: "Mã cuộc họp",
                meetingIDCodeCustomer: "Tên, id, mã khách hàng",
                MeetingIdIsRequired: "meetingId là bắt buộc",
                meetingInfo: "Thông tin cuộc họp",
                meetingList: "Danh sách cuộc họp",
                meetingLocation: "Địa điểm họp",
                meetingMuteOnStart: "Tắt tiếng khi tham gia",
                meetingName: "Tên cuộc họp",
                meetingNamePlaceHolder: "Nhập tên cuộc họp",
                meetingType: "Hình thức",
                MeetingNameIsRequired: "Tiêu đề lịch họp là bắt buộc ",
                meetingNoRecordedFile: "Không có ghi hình",
                meetingProgressRecorded: "Đang xử lý ghi hình",
                meetingCode: "Mã phòng họp",
                meetingCodePlaceHolder: "Nhập mã phòng họp",
                MeetingNotFound: "Mã phòng họp không tồn tại hoặc đã bị xóa",
                meetingOperator: "Người điều hành",
                meetingOperatorBadge: "Điều hành",
                meetingParticipant: "Người tham gia",
                meetingParticipantsJoined: "Đang tham gia ({count})",
                notEnoughStorageToRecord: "Không đủ dung lượng để ghi hình",
                notEnoughAiFeatureLimit: "Không đủ hạn mức để sử dụng tính năng AI",
                meetingParticipantsList: "Người tham dự",
                meetingParticipantsMaxCount: "Tối đa {count} người",
                meetingParticipantsNotJoined: "Chưa tham gia ({count})",
                meetingPendingMsg: "Cuộc họp chưa bắt đầu",
                meetingPrivateChatAllow: "Cho phép trò chuyện riêng tư",
                meetingPublicChatAllow: "Cho phép trò chuyện công khai",
                meetingRestartMsg: "Bạn có thể bắt đầu lại cuộc họp",
                meetingScheduledTime: "Thời gian dự kiến",
                meetingSearchPlaceholder: "Tìm theo mã, tên khách hàng",
                MeetingSecretKeyRequired: "SecretKey là bắt buộc",
                meetingShareCamera: "Chia sẻ camera",
                meetingsListToday: "Danh sách các cuộc họp diễn ra hôm nay",
                meetingStatusCancelled: "Đã huỷ",
                MeetingStatusEnded: "Cuộc họp đã kết thúc",
                meetingStatusEnded: "Đã kết thúc",
                meetingStatusInProgress: "Đang diễn ra",
                MeetingStatusInvalid: "Trạng thái cuộc họp không đúng",
                MeetingStatusPending: "Cuộc họp chưa bắt đầu",
                meetingStatusPending: "Đang chờ",
                meetingSumary: "Tóm tắt cuộc họp",
                activeGMToken: "Token tích hợp",
                both: "Cả hai",
                meetingStart: "Bắt đầu cuộc họp",
                meetingReopen: "Mở lại cuộc họp",
                meetingTableActualDateTimeTitleAttr: "Bắt đầu: {start}\nKết thúc: {end}",
                meetingTableScheduledDateTimeTitleAttr: "Bắt đầu (dự kiến): {start}\nKết thúc (dự kiến): {end}",
                meetingTurnOffCamera: "Tắt Camera",
                meetingTypeClosed: "Cuộc họp riêng tư",
                meetingTypeOpen: "Cuộc họp công khai",
                mini: "Thu nhỏ",
                more: "Thao tác khác",
                MinimumNumOfParticipants: "Số người tham gia cuộc họp phải ít nhất 1 người",
                MinScheduleDuration: "Khoảng thời gian diễn ra tối thiểu là 15 phút",
                minutes: "phút",
                ModelNotFound: "Không tìm thấy thông tin",
                months: "Tháng",
                mustChangeDefaultPassword: "Phải thay đổi mật khẩu mặc định",
                NameMaxLength: "Độ dài Họ Tên tối đa 100 ký tự",
                namePlaceHolder: "Họ và tên",
                accessCodePlaceHolder: "Mã truy cập",
                nameUnit: "Tên đơn vị",
                nameFeatureRequired: "Tên chức năng không được để trống.",
                descriptionFeatureRequire: "Mô tả chức năng không được để trống.",
                nearExpired: "Sắp hết hạn",
                net: "NET",
                newAccountsDay: "Tài khoản mới trong ngày",
                newApiConfig: "Tạo mới hạ tầng",
                newMeetingDefaultName: "Cuộc họp ngày ",
                newPassword: "Mật khẩu mới",
                NewPasswordInvalid: "Mật khẩu mới trùng mật khẩu hiện tại",
                NewPasswordRequired: "Mật khẩu là bắt buộc",
                newRegion: "Tạo khu vực kinh doanh",
                no: "Không",
                noActiveSub: "Tài khoản chưa có gói cước. Hãy đăng ký để bắt đầu sử dụng GoMeet.",
                noData: "Không có dữ liệu",
                noEvent: "Không có lịch họp",
                noFoundSearch: "Không tìm thấy kết quả nào.",
                noRegisteredService: "Chưa có dịch vụ được đăng ký",
                NotAllowedToJoinMeeting: "Phòng họp đã đạt tối đa số lượng người tham dự",
                note: "Ghi chú",
                attention: "Lưu ý",
                deleteRecordingWarning: "dữ liệu sau khi xoá sẽ không thể khôi phục, hãy tải các bản ghi của các cuộc họp quan trọng về máy trước khi thực hiện chức năng này!",
                NoActiveApiConfigForPlan: "Không tìm thấy hạ tầng hoạt động cho gói cước hiện tại",
                notGetVerificationEmailYetC: "Nếu chưa nhận được email,",
                notSendEmailInvitation: "Chưa gửi email mời tham gia",
                notSendMeetingCancelEmail: "Chưa gửi email báo huỷ lịch họp",
                notSendMeetingUpdateEmail: "Chưa gửi email thay đổi lịch họp",
                numberDaysKeepLog: "Số ngày lưu giữ nhật ký",
                numberOfConcurrentMeetings: "Số cuộc họp đồng thời",
                ConcurrentMeetings: "CH đồng thời",
                NumberOfConcurrentMeetings: "Số lượng cuộc họp đồng thời phải trong khoảng 1: 100",
                NumberOfConcurrentMeetingsIsRequired: "Số lượng cuộc họp đồng thời  là bắt buộc",
                NumberOfConcurrentMeetingsLength: "Số lượng cuộc họp đồng thời từ 1: 100",
                NumberOfDaysUsage: "Thời gian sử dụng từ 1 - 36",
                NumberOfDaysUsageIsRequired: "Thời gian sử dụng gói cước là bắt buộc",
                numberOfMeetingsPerMonth: "Số cuộc họp trong 1 tháng",
                NumberOfMeetingsPerMonth: "Số cuộc họp trong một tháng từ 1 - 10000",
                NumberOfMeetingsPerMonthIsRequired: "Số cuộc họp trong một tháng là bắt buộc",
                NumberOfParticipantIsExceeded: "Số lượng người tham gia vượt quá số lượng cho phép",
                numCameraOn: "Camera bật",
                numMeeting: "Số cuộc họp",
                numOfActualParticipants: "Số người tham gia thực tế",
                numOfParticipants: "Số người tham gia tối đa",
                numVoiceOn: "Mic bật",
                official: "Chính thức",
                ok: "Đồng ý",
                OldPasswordInvalid: "Mật khẩu hiện tại không đúng",
                OnlyDelMeetingInPendingStatus: "Không thể xoá cuộc họp đang diễn ra",
                onlyShowCameraForOperator: "Chỉ hiển thị webcam cho người trình bày",
                onOff: "Bật/Tắt",
                openGmail: "Mở Gmail",
                openInApp: "Mở trong ứng dụng",
                openInBrowser: "Mở trên Web",
                openOutlook: "Mở Outlook",
                or: "Hoặc",
                organ: "Cơ quan nhà nước",
                os: "Hệ điều hành",
                other: "Khác",
                outside: "Ngoài VNPT",
                overview: "Tổng quan",
                ownedBy: "Thuộc sở hữu",
                packageStatus: "Trạng thái gói cước",
                packageType: "Loại gói cước",
                PageRangeInteger: "Page trong khoảng từ 1 - 214748364",
                PageRequired: "Page là bắt buộc nhập",
                PageSizeRange: "PageSize trong khoảng 10 - 1000",
                PageSizeRequired: "PageSize là bắt buộc nhập",
                ParticipanNameMaxLength: "Độ dài Họ Tên tối đa 255 ký tự ",
                participantJoinUrl: "Người tham dự/Điểm cầu",
                ParticipantNameIsRequired: "Họ tên người tham gia là bắt buộc ",
                ParticipantRequired: "Vui lòng nhập thông tin người điều hành và tham dự",
                password: "Mật khẩu",
                passwordChangedSuccessful: "Đổi mật khẩu thành công. Bạn vui lòng đăng nhập lại.",
                PasswordContainMailPrefix: "Để đảm bảo an toàn thông tin, mật khẩu không được chứa nội dung của email!",
                PasswordContainsDatePattern: "Để đảm bảo an toàn thông tin, mật khẩu không được chứa thông tin ngày tháng năm sinh!",
                PasswordContainsDisallowedPatterns: "Để đảm bảo an toàn thông tin, mật khẩu không được chứa các nội dung như: chuỗi chữ cái ABCD, 1234, 2345, 3456,...",
                PasswordContainsRepeatingCharacters: "Để đảm bảo an toàn thông tin, mật khẩu không được chứa 3 ký tự giống nhau liên tiếp!",
                PasswordContainsWhitespace: "Mật khẩu không được chứa khoảng trắng!",
                PasswordContainUsername: "Để đảm bảo an toàn thông tin, mật khẩu không được chứa nội dung của tên đăng nhập!",
                passwordDescription: "Mô tả mật khẩu",
                passwordFormat: "Mật khẩu tối thiểu 8 ký tự bao gồm ký tự số, chữ thường, chữ in hoa và ký tự đặc biệt.",
                passwordhasbeenusedbefore: "Mật khẩu mới không được trùng với mật khẩu hiện tại",
                PasswordInWordlist: "Để đảm bảo an toàn thông tin, không được sử dụng mật khẩu dễ đoán!",
                PasswordLength: "Mật khẩu tối thiểu 6 ký tự và tối đa 32 ký tự",
                passwordLockedOut: "Khoá tài khoản sau khi đăng nhập thất bại",
                passwordLockedOutDuration: "Khoá tài khoản sau bao nhiêu phút",
                passwordMaxLength: "Chiều dài tối đa của mật khẩu",
                PasswordMaxLength: "Mật khẩu tối đa 32 ký tự",
                passwordMinLength: "Chiều dài tối thiểu của mật khẩu",
                PasswordNotMatch: "Xác nhận mật khẩu không đúng",
                passwordPattern: "Biểu thức xác thực mật khẩu",
                passwordPolicy: "Chính sách mật khẩu",
                PasswordPolicyInvalid: "Chiều dài tối đa mật khẩu phải lớn hơn chiều dài tối thiểu",
                PasswordPolicyLength: "Chiều dài mật khẩu từ 6 - 30 ký tự!",
                PasswordPolicyRegex: "Mật khẩu tối thiểu 8 ký tự bao gồm ký tự số, chữ thường, chữ in hoa và ký tự đặc biệt!",
                PasswordRequired: "Mật khẩu là bắt buộc nhập",
                passwordResetSuccessful: "Đặt lại mật khẩu thành công",
                setupConfigSuccessful: "Thiết lập cấu hình thành công",
                passwordsNotMatch: "Mật khẩu không khớp",
                passwordValidationFailedMessage: "Thông báo xác thực mật khẩu không thành công",
                PasswordValidityPeriod: "Số ngày hiệu lực của mật khẩu trong khoảng 1 - 3650 ngày",
                passwordValidityPeriod: "Số ngày hiệu lực của mật khẩu",
                pending: "Đang chờ",
                personal: "Cá nhân",
                PhoneMaxLength: "Số điện thoại tối đa 50 ký tự",
                phoneNumber: "Số điện thoại",
                tongsocuochop: "Số cuộc họp",
                PhoneNumberMinLength: "Độ dài Số Điện Thoại ít nhất 10 ký tự số",
                PhoneNumberRequired: "Số điện thoại là bắt buộc",
                phonePlaceHolder: "Số điện thoại",
                planExpireGt2Months: "Còn hạn trên 2 tháng",
                planExpireLt2Months: "Còn hạn dưới 2 tháng",
                pleaseChoose: "Vui lòng chọn",
                pleaseEnterDocumentExpDate: "Vui lòng nhập ngày hết hạn giấy tờ",
                pleaseEnterDocumentIssueDate: "Vui lòng nhập ngày cấp giấy tờ",
                pleaseSelectMeetingStartDate: "Vui lòng chọn ngày bắt đầu cuộc họp",
                pleaseSelectMeetingStartDatetime: "Vui lòng chọn ngày giờ bắt đầu cuộc họp",
                pleaseSelectValidDate: "Vui lòng chọn ngày hợp lệ",
                portalHome: "Trang chủ",
                PortLength: "Port trong phạm vi 0-65535",
                PortPolicyError: "Thay đổi port không thành công",
                private: "Riêng tư",
                privateSub1: "Thông tin cuộc họp sẽ được gửi riêng cho những người có trong danh sách, chỉ có những người này mới được phép tham gia vào cuộc họp.",
                province: "Tỉnh/thành phố",
                public: "Công khai",
                QRCodeText: "Mã QR tham gia",
                otherInfo: "Thông tin khác",
                securityCodeLabel: "Mã bảo mật",
                joinLink9DigitsLabel: "Link tham dự bằng mã 9 số",
                reopenMeetingLink: "Link mở lại phòng họp",
                reopenMeetingTooltip: "Bạn có thể mở lại phiên họp sau khi kết thúc.\nNgười có link tham dự có thể tham gia lại.",
                reopenMeetingHint: "Liên kết này cho phép Chủ trì khôi phục phiên họp đã kết thúc để người tham dự truy cập lại.",
                reopenMeetingSecurityWarning: "Vì lý do bảo mật, tuyệt đối không chia sẻ liên kết này cho bất kỳ ai!",
                regionAdminList: "Danh sách khu vực kinh doanh",
                regionCode: "Mã khu vực",
                regionName: "Tên khu vực",
                register: "Đăng ký",
                registerAccount: "Đăng ký",
                registerAccountSubtitle: "Tạo và tổ chức các cuộc họp, đào tạo, dạy học trực tuyến",
                registerAccountSubtitle2: "của VNPT GoMeet",
                registerConfirmCorrectInfo: "Vui lòng xác nhận các thông tin trên là chính xác trước khi thực hiện đăng ký dịch vụ",
                registerService: "Đăng ký dịch vụ",
                registerServiceInfo: "Thông tin dịch vụ đăng ký",
                registerServiceSuccessful: "Đăng ký dịch vụ thành công",
                reload: "Tải lại",
                reNew: "Tạo lại",
                renewConfirmCorrectInfo: "Vui lòng xác nhận các thông tin trên là chính xác trước khi thực hiện gia hạn dịch vụ",
                renewService: "Gia hạn dịch vụ",
                renewServiceSuccess: "Gia hạn dịch vụ thành công",
                settingServiceSuccess: "Cập nhật thành công",
                meetingConcurrentParticipantsLimit: "Số người tham dự",
                meetingParticipants: "Người tham dự",
                participants: "người tham dự",
                settingService: "Cài đặt dịch vụ",
                settingQuota: "Số CH, người tham dự",
                maxParticipantPool: "Tổng số người tham dự (chung)",
                totalParticipantPool: "Tổng số người tham dự",
                recordingStorageNotice: "Bạn không thể sử dụng được tính năng Ghi hình nếu dung lượng còn lại dưới 200MB",
                meetingNotRecordable: "cuộc họp này không thể ghi hình",
                storageCleanupPrompt: "Vui lòng xóa bớt các bản ghi để sử dụng được tính năng ghi hình. Xem và quản lý dung lượng",
                quotaRenewPrompt: "Quý khách có thể nâng cấp gói cước để mua thêm dung lượng AI. Trường hợp không nâng cấp, hạn mức sẽ tự động được đặt lại vào ngày {date}.",
                recordingStorageRequirement: "Ghi hình cần dung lượng lưu trữ tối thiểu 200MB. Hiện tại bạn chỉ còn {storage}, nên",
                recordingRetentionNotice: "Mỗi bản ghi hình được lưu trữ tối đa 90 ngày",
                quotaAIBelow10Percent: "Hạn mức sử dụng AI còn lại dưới 10%, vì vậy cuộc họp này không thể sử dụng các tính năng AI",
                quotaTotal: "Hạn mức AI",
                aiQuotaUnlimited: "Hạn mức: Không giới hạn",
                report: "Báo cáo",
                reportNumMeeting: "Báo cáo số lượng phiên họp",
                required: "Bắt buộc",
                resendVerificationEmail: "Gửi lại",
                resetAdminAccountPassword: "Đặt lại mật khẩu tài khoản QTDV",
                resetPassword: "Đặt lại mật khẩu",
                restrictCustomer: "Hạn chế/phản đối",
                restrictCustomerConfirmation: 'Rút lại sự đồng ý cho phép VNPT GoMeet ngừng xử lý dữ liệu cá nhân và Khóa tài khoản  của khách hàng "{name}". Bạn có chắc chắn muốn thực hiện hành động này không?',
                resultCount: "Có {count} kết quả",
                role: "Vai trò",
                roleAdmin: "Quản trị",
                roleUser: "Người dùng",
                saleAccount: "Tài khoản TTKD",
                saleAccountList: "Danh sách tài khoản TTKD T/TP",
                TTKD: "TTKD",
                ttkd2Cap: "TTKD (2 cấp)",
                saleArea1: "Khu vực (địa bàn)",
                saleArea2: "Khu vực kinh doanh",
                saleArea: "Khu vực",
                save: "Lưu",
                saveChanges: "Lưu thay đổi",
                saveConfigToken: "Lưu cấu hình",
                saveSettingsSuccessful: "Lưu cài đặt thành công",
                ScheduleDurationIsRequired: "Khoảng thời gian diễn ra buổi họp bắt buộc nhập",
                ScheduleStartTimeIsRequired: "Thời gian bắt đầu cuộc họp bắt buộc nhập.",
                search: "Tìm kiếm",
                SecretKeyExpired: "Mã bí mật hết hiệu lực",
                selectAll: "Chọn tất cả",
                selectedWithCount: "Đã chọn ({count})",
                selectedPackageCount: "Gói cước ({count})",
                selectedWithCountRegis: "Gói cước đã đăng ký ({count})",
                selectEffDate: "Chọn ngày hiệu lực",
                selectExpDate: "Chọn ngày hết hạn",
                selectRangeDate: "Từ ngày - Đến ngày",
                sendEmail: "Gửi email",
                sendEmailAndSms: "Gửi email & SMS",
                sendEmailInvitation2: "Gửi email mời tham gia",
                sendEmailInvitation: "Gửi email mời",
                sendEmailInvitationConfirm2: "Gửi email mời tham gia đến {email}?",
                sendEmailInvitationConfirm: "Gửi email mời tham gia?",
                sendEmailInvitationSuccessful: "Gửi email mời tham gia thành công",
                sendEmailInvitationToAll: "Gửi email mời đến tất cả những người tham gia",
                sendEmailSuccessful: "Gửi email thành công",
                sendMeetingCancelEmail: "Gửi email báo huỷ lịch họp",
                sendMeetingCancelEmailSuccessful: "Gửi email báo huỷ lịch họp thành công",
                sendMeetingCancelEmailToAll: "Gửi email báo huỷ lịch họp đến tất cả những người tham gia",
                sendMeetingUpdateEmail: "Gửi email thay đổi lịch họp",
                sendMeetingUpdateEmailSuccessful: "Gửi email thay đổi lịch họp thành công",
                sendMeetingUpdateEmailToAll: "Gửi email thay đổi lịch họp đến tất cả những người tham gia",
                sendServiceRenewReminderEmail: "Gửi email nhắc nhở gia hạn",
                sendServiceRenewReminderEmailConfirm: "Gửi email nhắc nhở gia hạn?",
                sendServiceRenewReminderEmailSuccessful: "Gửi email thông báo gia hạn thành công",
                sendSms: "Gửi SMS",
                fixed: "Cố định",
                session: "Phiên (Session)",
                concurrentMeeting: "Cuộc họp đồng thời",
                sendSmsInvitation2: "Gửi SMS mời tham gia",
                sendSmsInvitation: "Gửi SMS mời",
                sendSmsInvitationConfirm: "Gửi SMS mời tham gia đến số điện thoại {phone}?",
                sendSmsInvitationSuccessful: "Đã gửi SMS mời tham gia đến số điện thoại {phone}",
                sendSmsSuccessful: "Gửi SMS thành công",
                serviceAdminAccount: "Tài khoản QTDV",
                serviceAdminAccountList: "Danh sách tài khoản quản trị dịch vụ",
                serviceInfo: "Thông tin dịch vụ",
                servicePrice: "Giá cước",
                serviceRegisterHistory: "Lịch sử đăng ký gói cước",
                serviceStartDate: "Ngày bắt đầu sử dụng dịch vụ",
                settings: "Cài đặt",
                SigninCas_Service_Require: "Service là bắt buộc nhập",
                SigninCas_Ticket_Require: "Ticket là bắt buộc nhập",
                enterAccountInformation: "Thông tin tài khoản",
                signUpIAgreeWith: "Tôi đã đọc và đồng ý với VNPT về",
                signUpPrivacyPolicy: "Chính sách bảo mật",
                personalDataProtectionPolicy: "Chính sách bảo vệ dữ liệu cá nhân",
                productVnptGoMeet: "của VNPT GoMeet",
                byJoiningMeetingYouAccept: "Bằng việc tham gia, bạn đã đồng ý với",
                signupSuccessful: "Đăng ký thành công",
                signupSuccessfulSubtitle: "Bạn đã thực hiện đăng ký thành công tài khoản, vui lòng đăng nhập vào hệ thống để trải nghiệm dịch vụ.",
                signUpTermOfUse: "Điều khoản sử dụng",
                smartVoiceToken: "Smart Voice",
                smartVoiceTokensTitle: "Quản lý SmartVoice",
                smartVoiceTokenSystem: "SmartVoice",
                viewRecordingAudioWithSize: "Xem ghi âm (MP3, {size})",
                viewRecordingVideoWithSize: "Xem ghi hình ({size})",
                recordingContent: "Nội dung ghi hình",
                start: "Bắt đầu",
                startDate: "Ngày bắt đầu",
                StartMeetingExceed: "Số lượng cuộc họp đồng thời vượt quá số lượng cho phép của gói đăng ký.",
                startMeetingWarning: "Vui lòng không đóng trình duyệt khi chưa có người tham dự",
                startNewMeeting: "Tạo nhanh cuộc họp",
                startMeetingWithoutRecord: "Tạo cuộc họp không có ghi hình",
                startMeetingNoRecord: "Tạo cuộc họp nhanh không có chức năng ghi hình",
                StartTimeIsRequired: "Ngày bắt đầu sử dụng bắt buộc nhập",
                status: "Trạng thái",
                stayLoggedIn: "Ghi nhớ đăng nhập",
                storage: "Lưu trữ",
                capacity: "Dung lượng",
                storageType: "Loại dung lượng",
                capacitySubscriptions: "Dung lượng gói cước",
                currentExtraCapacity: "Dung lượng đã bổ sung",
                purchaseExtraCapacity: "Dung lượng mua thêm",
                totalCapacityAfterPurchase: "Tổng dung lượng",
                extraCapacity: "Dung lượng bổ sung",
                usedStorageSize: "Dung lượng đã sử dụng",
                storageExpiredDay: "Với mỗi bản ghi, hệ thống chỉ lưu trữ tối đa {day} ngày",
                storageQuotaReset: "Hạn mức AI sẽ được đặt lại vào ngày: {date}",
                storageTotal: "Tổng dung lượng",
                storageAccount: "Dung lượng",
                storageCapacity: "Dung lượng lưu trữ",
                storageFullAlert: "Đã sử dụng hết dung lượng lưu trữ ({used} / {total} MB)",
                storageGb: "Dung lượng (GB)",
                storageHistory: "Gói cước lưu trữ",
                storageInfo: "Thông tin lưu trữ",
                storeBothLocalAndFtp: "Lưu trữ cả local và FTP",
                storeLocal: "Lưu trữ trên local",
                storeViaFtp: "Lưu trữ thông qua FTP",
                subCreatedDate: "Ngày đăng ký",
                SubcriptionPlanNameMaxLength: "Tên gói cước tối đa 255 ký tự",
                SubcriptionPlanNameRequired: "Tên gói cước là bắt buộc",
                SubcriptionPlanPackageTypeIsRequired: "PackageType là bắt buộc",
                SubcriptionPlanPriceIsRequired: "Đơn giá là bắt buộc",
                SubjectMaxLength: "Độ dài Tiêu đề tối đa 255 ký tự ",
                joinOnBrowser: "Tham gia trên trình duyệt",
                SubjectRequired: "Tiêu đề không được bỏ trống",
                subPlanCode: "Mã gói cước",
                subPlanList: "Danh sách gói cước",
                subPlanName: "Tên gói cước",
                subscriptionInfo: "Thông tin gói cước",
                subscriptionLength: "Thời gian sử dụng",
                subscriptionPlan: "Gói cước",
                SubscriptionPlanIdIsRequired: "ID Gói cước bắt buộc nhập",
                subscriptionStatusFilterSelectLabel: "Thời hạn",
                subscriptionToRegister: "Gói cước đăng ký",
                subscriptionToUpgradeTo: "Gói cước đăng ký",
                success: "Thành công",
                summary: "Tóm tắt",
                transcript: "Transcript",
                summaryBySTT: "Tóm tắt từ Speech To Text (STT)",
                summaryByTime: "Tóm tắt từ dòng thời gian (Timeline)",
                summaryOfAllUser: "Tóm tắt người tham gia",
                systemLogs: "Nhật ký hệ thống",
                tableView: "Bảng",
                taxCode: "Mã số thuế",
                tdagency: "Cơ quan TĐ",
                TemplateNotFound: "Không tìm thấy mẫu email",
                tenKhuVuc: "Tên khu vực",
                test: "Kiểm tra",
                testing: "Thử nghiệm",
                themGoiCuoc: "Thêm gói cước",//
                themKhuVuc: "Thêm mới khu vực",
                thisWeek: "Tuần này",
                thongtinkhuvuc: "Thông tin khu vực",
                timeEndValid: "Thời gian kết thúc không hợp lệ",
                title: "Tiêu đề",
                to: "Đến",
                toDate: "Đến ngày",
                TokenAPIContactImport: "Bearer Token:",
                tokenInfo: "Thông tin token tích hợp",
                TokenInValid: "Bearer Token bị null hoặc không hợp lệ",
                TokenInvalid: "Hết phiên làm việc. Vui lòng đăng nhập lại",
                TokenRequired: "Bearer Token bị null hoặc không hợp lệ",
                totalCancelledMeetings: "Tổng số cuộc họp bị huỷ",
                totalCustomerAccounts: "Tổng số tài khoản được tạo",
                totalCustomers: "Tổng số khách hàng",
                totalEndedMeetings: "Tổng số cuộc họp đã kết thúc",
                totalInprogressMeetings: "Tổng số cuộc họp đang diễn ra",
                totalMeeting: "Tổng số cuộc họp",
                totalMeetings: "Tổng số phòng họp được tạo",
                totalPackages: "Tổng số gói cước được tạo",
                totalPendingMeetings: "Tổng số cuộc họp sắp diễn ra",
                trial: "Dùng thử",
                tukhoatimkiem: "Nhập từ khóa tìm kiếm",
                inputNameRegion: "Nhập tên khu vực",
                type: "Phân loại",
                typeError: "Loại lỗi",
                TypeForm: "Hình thức họp",
                UnableToDelete: "Không thể xoá dữ liệu ràng buộc",
                UnableToDeleteAcc: "Bạn không thể xóa tài khoản này. Tài khoản này đang tham gia vào hệ thống.",
                UnableToDeletePackage: "Gói cước đã sử dụng và không thể xoá",
                unactive: "Không hoạt động",
                UnauthorizeEditContact: "Bạn không thể cập nhật thông tin Người tham gia không phải do Bạn tạo",
                underTheUnit: "Thuộc đơn vị",
                unexpired: "Còn hiệu lực",
                unitTime: "Đơn vị",
                unlockAccount: "Mở khoá tài khoản",
                unlockAccountConfirmation: 'Bạn có chắc mở khoá tài khoản "{account}"?',
                unlockAccountSuccess: "Mở khoá tài khoản thành công",
                unsuccessful: "Không thành công",
                unsuccess: "Không thành công",
                update: "Cập nhật",
                updateAccountInfo: "Cập nhật thông tin tài khoản",
                updateAdminAccount: "Cập nhật thông tin tài khoản",
                updateApiConfig: "Chỉnh sửa hạ tầng",
                updateApiConfigSuccessful: "Chỉnh sửa hạ tầng thành công",
                updateApp: "Cập nhật thông tin ứng dụng",
                updateAppSuccessful: "Cập nhật thông tin ứng dụng thành công",
                updateCalendarLocationSuccessful: "Cập nhật địa điểm thành công",
                updateContact: "Cập nhật liên hệ",
                updateCustomerInfo: "Cập nhật thông tin khách hàng",
                updateCustomerInfoSuccessful: "Cập nhật thông tin khách hàng thành công",
                updateDate: "Cập nhật",
                updateEmailTemplateSuccessful: "Cập nhật mẫu email thành công",
                updateInfo: "Cập nhật thông tin",
                updateMeetingParticipant: "Cập nhật thông tin người tham gia",
                updatePersonalInfo: "Cập nhật thông tin cá nhân",
                updateRegion: "Cập nhật khu vực kinh doanh",
                updateRegionSuccessful: "Cập nhật khu vực thành công",
                UpdateRoleInvalid: "Thông tin Role không hợp lệ, role bắt buộc là 'Customer', 'User', 'View'",
                updateSmartVoiceSuccessful: "Cập nhật SmartVoice Token thành công.",
                updateSubPlan: "Chỉnh sửa gói cước",
                updateSubPlanSuccessful: "Chỉnh sửa gói cước thành công",
                UpdateSuccess: "Cập nhật thành công",
                updateSuccessful: "Cập nhật thành công",
                upgradeConfirmCorrectInfo: "Vui lòng xác nhận các thông tin trên là chính xác trước khi thực hiện thay đổi dịch vụ",
                upgradeDurationExtension: "Số {unit} sử dụng thêm",
                upgradeOption0: "Sử dụng đến ngày kết thúc của gói đang sử dụng",
                upgradeOption1: "Thêm thời gian sử dụng",
                upgradeOption: "Hình thức thay đổi",
                upgradeService: "Thay đổi dịch vụ",
                upgradeServiceSuccessful: "Thay đổi dịch vụ thành công",
                upgradePlanDescription: "Bạn có thể nâng cấp gói dịch vụ để tăng dung lượng và quản lý thêm nhiều bản ghi quan trọng",
                Upload_failed: "Tải lên hình ảnh thất bại",
                Upload_failed_code_exist: "Lỗi: Mã code đã tồn tại",
                Upload_success: "Tải lên hình ảnh thành công",
                UrlNotAllowed: "Url không được chấp nhận",
                useFullSystem: "Sử dụng thiết lập của hệ thống",
                username: "Tên đăng nhập",
                usernameDescription: "Chấp nhận ký tự chữ thường, in hoa và dấu gạch dưới _",
                UsernameDuplicate: "Trùng tên đăng nhập",
                UsernameExist: "Tài khoản đã tồn tại",
                UsernameMaxLength: "Tên đăng nhập tối đa 32 ký tự",
                UsernameNotFound: "Tài khoản không tồn tại.",
                usernameOrEmail: "Tài khoản",
                UsernameRequired: "Tên đăng nhập là bắt buộc nhập",
                UserNotFound: "Không tìm thấy thông tin tài khoản",
                vatTax: "Thuế VAT",
                verificationEmailSent: "Gửi email xác thực thành công",
                verificationEmailSentSubtitle: "Chúng tôi đã gửi email đến {email}.\nVui lòng nhấp vào liên kết xác nhận trong email để hoàn tất xác thực và bắt đầu sử dụng VNPT GoMeet.",
                version: "Phiên bản",
                view: "Xem",
                viewMeetingRecordedFile: "Xem ghi hình",
                viewmore: "Xem thêm",
                viewOnly: "Chỉ xem",
                viewStats: "Xem thống kê",
                viewDetails: "Xem chi tiết",
                viewTemplateAPIImportContact: "Xem hướng dẫn",
                vinaphone: "Vinaphone",
                vt_ttp: "VT-TTP",
                vnptGroup: "Tập đoàn VNPT",
                warningIdIconSub: "Chưa có hình ảnh nhận diện khuôn mặt. Vào Danh bạ để cập nhật ảnh khuôn mặt cho người này!",
                WebhookConfigurationIsExisting: "Thông tin cấu hình webhookConfiguration đã tồn tại",
                weeklyCalendar: "Lịch tuần",
                weeklyCalendarList: "Danh sách lịch tuần",
                weeks: "Tuần",
                welcomeMsg: "Chào mừng bạn đến với VNPT GoMeet",
                welcomeMsgSubtitle: "Vui lòng điền các thông tin sau đây để hoàn tất đăng ký tài khoản",
                welcomeToGoMeet: "Chào mừng bạn đến với VNPT GoMeet",
                widgetDescription: " Widget cho phép mọi người dễ dàng nhúng cửa sổ phòng họp vào trong trang web của họ. Giúp mọi người sử dụng GoMeet dễ dàng hơn",
                withdrawConsent: "Rút lại đồng ý",
                withDrawCustomer: "Rút lại sự đồng ý xử lý dữ liệu",
                withDrawCustomerModalTitle: "Rút lại sự đồng ý xử lý dữ liệu",
                withDrawCustomerModalBody: "Rút lại sự đồng ý đồng nghĩa với việc bạn đồng ý với VNPT về việc <b>khóa tài khoản và ngừng sử dụng dịch vụ VNPT GoMeet</b>. Chi tiết vui lòng tham khảo tại <b>điều 5, mục 4</b> trong <b>{policyName}</b>.<br/><br/>Bạn có chắc chắn muốn rút lại sự đồng ý xử lý dữ liệu?",
                withDrawCustomerSuccess: "Thực hiện thành công",
                withDrawCustomerConfirmation: 'Rút lại sự đồng ý cho phép VNPT GoMeet ngừng xử lý dữ liệu cá nhân và Khóa tài khoản của khách hàng "{name}". Bạn có chắc chắn muốn thực hiện hành động này không?',
                workDepartment: "Phòng ban",
                workOrganization: "Đơn vị",
                workOrganizationName: "Tên đơn vị",
                workTitle: "Chức danh",
                WrongPasswordAttempt: "Số lần được phép nhập mật khẩu sai trong khoảng 1 - 100 lần",
                wrongPasswordAttempt: "Số lần được phép nhập mật khẩu sai",
                years: "Năm",
                yes: "Có",
                yourStorageCapacity: "Dung lượng lưu trữ",
                yourPlanRemaining: "Gói cước của bạn còn",
                countThisMonth: "Số cuộc họp đã diễn ra trong tháng",
                limitReached: "đạt số giới hạn của gói cước",
                user: "Người dùng",
                trungtendanhba: "Tên danh bạ bị trùng",
                trungsdt: "Trùng số diện thoại trong danh bạ",
                trungemail: "Trùng email trong danh bạ",
                socuochopdatao: "Số cuộc họp đã tạo",
                socuochopdaketthuc: "Số cuộc họp đã kết thúc",
                socuochopdahuy: "Số cuộc họp đã hủy",
                socuochopdaxoa: "Số cuộc họp đã xóa",
                datao: "Đã tạo",
                hoanthanh: "Hoàn thành",
                daxoa: "Đã xóa",
                deleted: "Đã xóa",
                dahuy: "Đã hủy",
                email: "Email",
                name: "Tên",
                thoidiemtao: "Thời điểm tạo",
                goicuoc: "Gói cước",
                songayconhieuluc: "Số ngày còn hiệu lục",
                loaitaikhoan: "Loại tài khoản",
                Id: "Id",
                sanluongkhachhangtu: "Sản lượng khách hàng từ",
                songayconlai: "Số ngày còn lại",
                IdKH: "ID khách hàng",
                fileExcelNotData: "Tệp Excel không có dữ liệu",
                fileExcelFullName: "Họ tên không được dưới 2 ký tự",
                emailDuplicated: "Email trùng lặp",
                fileExcelReadError: "Lỗi đọc tệp Excel",
                userDuplicated: "Tên đăng nhập trùng lặp",
                fileExcelEmptyRowBetween: "Nội dung file excel không hợp lệ!",
                person: "người",
                useFeature: "Kích hoạt",
                alwaysEnabledByDefault: "Luôn sử dụng",
                featureConfiguration: "Cấu hình chức năng",
                faceIdConfig: "Xác thực khuôn mặt",
                voiceTextConfig: "Tóm tắt cuộc họp",
                generalInfo: "Thông tin chung",
                featureSettings: "Thiết lập chức năng",
                storageType_Fix: "Cố định",
                storageType_Session: "Phiên (SESSION)",
                storageType_Meeting: "Cuộc họp đồng thời",
                storage_Select_Sum: "Dung lượng lưu trữ tối đa {capacity}, lưu trữ  {days} ngày",
                storageTime: "Thời gian lưu trữ (ngày)",
                activePackage: "Kích hoạt",
                unactivePackage: "Ngừng hoạt động",
                storageCapacityNotAllowNull: "Dung lượng lưu trữ không được bỏ trống",
                storageTimeNotAllowNull: "Thời gian lưu trữ không được bỏ trống",
                outputStatistic: "Thống kê sản lượng",
                saleAreaShort: "KVKD",
                unitArea: "Đơn vị/KV",
                unitDepart: "Đơn vị, phòng ban",
                accountCreatedDate: "Ngày tạo tài khoản",
                desc: "Sắp xếp (Giảm dần)",
                numDuration: "Thời lượng cuộc họp",
                usedStotage: "Dung lượng đã sử dụng",
                timeSumaration: "Thời lượng tóm tắt cuộc họp",
                record: "Ghi hình",
                aiGen: "Tóm tắt (AI)",
                exportPDF: "Xuất báo cáo",
                day: "ngày",
                meetingStatis: "Thống kê cuộc họp",
                remainDays: "Còn {date} ngày",
                sum: "Tổng",
                timeMeeting: "T/lg",
                storageMeeting: "D/lg",
                meetingTime: "Thời gian họp",
                duration: "Thời lượng",
                participantCount: "Số người tham gia",
                package: "Gói cước",
                packageDetail: "Chi tiết gói cước",
                allowedCapacity: "Dung lượng cho phép",
                recordingCapacity: "Dung lượng ghi hình",
                pleaseRenewPackage: "Vui lòng gia hạn để tiếp tục tổ chức cuộc họp và sử dụng đầy đủ chức năng",
                pleaseUpgrade: "Vui lòng nâng cấp gói cước để tiếp tục tổ chức cuộc họp và sử dụng đầy đủ chức năng",
                pleaseRenewSoon: "Vui lòng gia hạn sớm để tránh gián đoạn cuộc họp",
                youCanStillHostUpTo: "Bạn có thể tổ chức cuộc họp tối đa",
                thankYouForBeingWithUs: "Cảm ơn bạn đã đồng hành cùng chúng tôi",
                summaryDuration: "Thời lượng tóm tắt",
                creatorId: "Id Tài khoản tạo",
                creatorAccount: "Tài khoản tạo",
                deletedAccount: "Tài khoản xóa",
                meetingStatistics: "Thống kê cuộc họp",
                contactInfo: "Liên hệ",
                totalActualDuration: "Tổng Th/lg",
                totalMeetingsRecorded: "Ghi hình",
                totalRecordingSize: "Dung lượng",
                totalMeetingsSummary: "Tổng số CH sử dụng tóm tắt",
                recordingStats: "Ghi hình",
                plan: "Gói",
                outputStatisticTitle: "BÁO CÁO THỐNG KÊ CHI TIẾT SẢN LƯỢNG CỦA KHÁCH HÀNG {NAME}",
                outputStatisticDetail: "Chi tiết sản lượng",
                totalVoices: "Micro bật",
                expiredPackage: "Hết hạn",
                END: "Đã kết thúc",
                PENDING: "Đang chờ",
                INPROGRESS: "Đang diễn ra",
                CANCEL: "Đã hủy",
                exporting: "Đang xuất file",
                CH: "CH",
                concurrent: "đồng thời",
                timeCount: "lượt",
                info: "Thông tin",
                TL: "TL",
                TG: "TG",
                TGia: "TGia",
                perMeeting: "người/CH",
                meetDay: "CH/ngày",
                // joinCode: "Mã tham gia",
                // inputInfoMeeting: "THAM GIA HỌP",
                // joinCodePlaceHolder: "Nhập mã tham gia",
                // joinMeetingDesc: "Điền thông tin để tham gia cuộc họp của bạn!",
                addMaxMeetingParticipant: "Thay đổi số lượng",
                addMaxMeetingParticipantSuccess: "Thay đổi số lượng người tham gia thành công",
                webinar_noti_private: "Lựa chọn đối tượng được phép tham gia ở chế độ họp thường. Người tham gia ở chế độ này có thể sử dụng mic, camera, chia sẻ màn hình, tùy theo quyền do host thiết lập.",
                webinar_noti_public: "Thiết lập ngưỡng về số lượng người tham gia được phép vào cuộc họp ở chế độ thường. Người tham gia ở chế độ này có thể sử dụng các chức năng như mic, camera, chia sẻ màn hình, tùy theo quyền được host cấu hình.Những người còn lại sẽ tham gia họp ở chế độ Webinar.",
                webinar_noti_2: "Những người không nằm trong danh sách, sẽ tham gia họp ở chế độ Webinar.",
                webinar: "Họp với chế độ webinar",
                on_time: "Vào lúc",
                webinar_define: "Chế độ Webinar trên VNPT GoMeet là hình thức tổ chức hội thảo, đào tạo hoặc sự kiện trực tuyến quy mô lớn qua Internet. Tính năng này cho phép một hoặc nhiều diễn giả (Host/Co-host/Panelist) chia sẻ âm thanh, video, màn hình, slide trình chiếu đến hàng trăm hoặc hàng nghìn người tham dự.",
                hh: "Chọn giờ",
                mm: "Chọn phút",
                numberOfNormalMeeting: "Số lượng tham gia ở chế độ thường",
                maxParticipantMeetings: "(Tối đa {number})",
                confirm: "Xác nhận",
                importParticipants: "Nhập từ file",
                previewData: "Dữ liệu từ file",
                notCorrect: "File không có dữ liệu hoặc không đúng định dạng",
                notCorrectFormat: "Tập tin không đúng mẫu theo yêu cầu, hãy kiểm tra lại",
                errorReadFile: "Có lỗi xảy ra khi đọc file",
                fileUpload: "File upload có {number}  lỗi. Kiểm tra lại dữ liệu",
                rowFile: "Dòng",
                ColumnFile: "Cột",
                importPhoneNotCorrect: "Số điện thoại không hợp lệ (kiểm tra chữ, ký tự đặc biệt, số điện thoại chỉ có 10 số)",
                importEmailNotCorrect: "Email không không đúng định dạng",
                importNotNull: "không được để trống",
                importFormatCell: "Định dạng ",
                importNoteCorrect: "không hợp lệ",
                importEmptyData: "Dữ liệu trống",
                importaNotiCorrectData: "Vui lòng chỉnh sửa dữ liệu sai xót",
                importPass: "Đã bỏ qua {number} dòng trùng",
                importSuccess: "Đã nhập thành công {number} người tham gia",
                importMaximum: "Số lượng vượt quá giới hạn {number} người",
                amountOfWebinarParticipants: "Số người tham gia ở chế độ thường",
                chooseSubscriptionNote: "Khi thay đổi dịch vụ, sẽ hủy dịch vụ hiện tại.",
                vnptGomeet: "của sản phẩm <span style='color:#004f9e'>VNPT GoMeet</span>",
                privacyAgreementTitle: "Thỏa thuận về bảo vệ dữ liệu cá nhân",
                labelIAM: "Tôi là:",
                labelMyEmail: "Email của tôi:",
                privacyAgreementNote: "Vào&nbsp;<b>{date}</b>&nbsp;tôi đã đọc và đồng ý với thỏa thuận về bảo vệ dữ liệu cá nhân do Công ty ban hành",
                changeContentTitle: "Nội dung thay đổi:",
                versionInfo: "Số phiên bản: {version} | Ngày hiệu lực: {date}",
                privacyPolicyTitle: "CHÍNH SÁCH BẢO VỆ DỮ LIỆU CÁ NHÂN ĐỐI VỚI KHÁCH HÀNG CỦA VNPT AI VÀ VNPT",
                ofProduct: "của sản phẩm",
                btnAcceptAndContinue: "ĐỒNG Ý VÀ TIẾP TỤC",
                btnLogoutOrReject: "ĐĂNG XUẤT / KHÔNG ĐỒNG Ý",
                managePrivacy: "Quản lý chính sách",
                privacyID: "ID",
                privacyRefNo: "Số hiệu",
                privacyVersion: "Phiên bản",
                privacyCreatedAt: "Khởi tạo",
                privacyUpdatedAt: "Cập nhật",
                privacyRequireVerify: "Yêu cầu xác nhận",
                privacyContentLink: "Link nội dung",
                privacyLatestUpdate: "Nội dung cập nhật mới nhất",
                privacyCreateTitle: "Tạo chính sách",
                privacyUpdateTitle: "Cập nhật chính sách",
                privacyEffectiveDate: "Ngày có hiệu lực",
                privacyChangeContent: "Nội dung thay đổi",
                privacyCreateSuccess: "Tạo chính sách thành công",
                privacyUpdateSuccess: "Cập nhật chính sách thành công",
                policyScrollToRead: "Cuộn xuống để đọc tiếp",
                policyReadToConfirm: "Vui lòng đọc hết nội dung để xác nhận!",
                policyRequireAgree: "Vui lòng tích chọn đồng ý điều khoản dịch vụ để tiếp tục.",
                policyRequireRead: "Bạn cần đọc hết nội dung chính sách!",
                unlockAccountCustomer: "Mở khóa cho khách hàng",
                recordingAudioOnly: "Ghi âm (MP3, chỉ có âm thanh)",
                recordingVideo: "Ghi hình (MP4, âm thanh & hình ảnh)",
                recordSound: "Ghi âm",
                recordVideo: "Ghi hình",
                deletePersonalData: "Xóa dữ liệu cá nhân",
                deletePersonalDataBody: "Tất cả dữ liệu cá nhân của bạn sẽ bị xóa vĩnh viễn khỏi hệ thống và không thể khôi phục. Bạn có chắc chắn muốn tiếp tục?",
                deletePersonalDataSuccess: "Đã xóa dữ liệu cá nhân thành công",
                deletePersonalDataRequestTitle: "Yêu cầu xóa dữ liệu cá nhân",
                deletePersonalDataDescription1: "Toàn bộ thông tin tài khoản và dịch vụ của Quý khách sẽ được xoá khỏi hệ thống khi yêu cầu này được thực hiện.",
                deletePersonalDataDescription2: "Vui lòng đọc thông tin chi tiết tại:",
                deletePersonalDataPolicyArticle: "Điều 5, mục 5",
                deletePersonalDataDescription3: "trong",
                deletePersonalDataDescription4: "của VNPT và điền đầy đủ thông tin yêu cầu xoá dữ liệu cá nhân dưới đây.",
                deletePersonalDataDescription5: "Chúng tôi sẽ xác minh và xử lý yêu cầu của Quý khách sớm nhất có thể kể từ khi nhận được yêu cầu này.",
                requestLabel: "Yêu cầu",
                requestPlaceholder: "Nhập yêu cầu...",
                submitRequestSuccess: "Gửi yêu cầu thành công!",
                submitRequest: "Gửi yêu cầu",
                selecting: "Đang chọn ({count})",
                authenticationConfig: "Thông tin xác thực",
                connectionConfig: "Cấu hình kết nối (GRPC)",
                domainGrpc: "Tên miền (GRPC)",
                portGrpc: "Cổng (GRPC)",
                authorizationLabel: "Authorization",
                tokenIdLabel: "Token ID",
                tokenKeyLabel: "Token Key",
                passwordFormatConfig: "Cấu hình định dạng mật khẩu",
                securityLockoutConfig: "Cấu hình bảo mật & Khóa tài khoản",
                chooseWhiteboard: "Chọn bảng trắng",
                chooseWhiteboardDesc: "Chọn một bảng trắng để sử dụng trong cuộc họp",
                noWhiteboardAvailable: "Không có bảng trắng khả dụng",
                noSelectWhiteboard: "Không chọn",
                noSelectWhiteboardDesc: "Bạn có thể chọn lại sau khi phiên họp đang diễn ra",
                createOtherWhiteboard: "Tạo bảng khác",
                whiteboardInMeeting: "Đang được sử dụng\nở cuộc họp: {id}",
                createWhiteboardModalTitle: "Tạo bảng trắng",
                editWhiteboardModalTitle: "Đổi tên bảng trắng",
                whiteboardNameLabel: "Tên bảng",
                whiteboardNamePlaceholder: "Nhập vào tên bảng trắng...",
                rename: "Đổi tên",
                createdWbText: "Tạo lúc: {time}",
                updatedWbText: "Cập nhật: {time}",
                ai_quota: "Hạn mức AI",
                purchaseAiQuotaTitle: "Hạn mức AI",
                aiQuotaType_NoUse: "Không sử dụng",
                aiQuotaType_Fixed: "Cố định",
                aiQuotaType_NoReset: "Không reset",
                aiQuotaType_Unlimited: "Không giới hạn",
                aiExtraDuration: "Thời lượng bổ sung",
                aiTotalDuration: "Tổng thời lượng",
                currentExtraAiMinutes: "Hạn mức đã bổ sung",
                purchaseExtraAiMinutes: "Hạn mức mua thêm",
                totalAiDurationAfterPurchase: "Tổng hạn mức",
                aiQuotaPeriodCycle: "Theo chu kỳ của gói",
                aiQuotaNoResetDescription: "Cộng dồn thời lượng chưa sử dụng sang chu kỳ tiếp theo",
                aiQuotaUnlimitedDescription: "Không giới hạn",
                aiQuotaDurationMinutes: "Thời lượng (Phút)",
                minutesCapital: "Phút",
                baseLimitLabel: "Hạn mức gói",
                whiteboardListTitle: "Danh sách bảng trắng",
                whiteboardNameColumn: "Tên bảng trắng",
                whiteboardCreatedColumn: "Ngày tạo",
                whiteboardModifiedColumn: "Cập nhật",
                whiteboardStatusColumn: "Trạng thái",
                whiteboardActionsColumn: "Thao tác",
                whiteboardInUse: "Đang sử dụng",
                whiteboardNotInUse: "Chưa sử dụng",
                whiteboardUpdateBtn: "Cập nhật",
                whiteboardViewBtn: "Xem",
                whiteboardDeleteBtn: "Xóa",
                whiteboardShareBtn: "Chia sẻ",
                whiteboardDeleteConfirm: "Bạn có chắc xóa vĩnh viễn bảng trắng \"{name}\"?",
                whiteboardDeleteSuccess: "Xóa bảng trắng thành công.",
                whiteboardShareModalTitle: "Chia sẻ \"{name}\"",
                whiteboardShareAccessLabel: "Quyền truy cập chung",
                whiteboardShareAccessRestricted: "Hạn chế",
                whiteboardShareAccessPublic: "Người khác có thể truy cập",
                whiteboardShareAccessRestrictedDesc: "Chỉ bạn mới có thể mở được liên kết này.",
                whiteboardShareAccessPublicDesc: "Bất kỳ ai có liên kết đều mở được.",
                whiteboardSharePermissionLabel: "Quyền thao tác",
                whiteboardSharePermissionView: "Chỉ xem",
                whiteboardSharePermissionEdit: "Được phép chỉnh sửa",
                whiteboardSharePermissionViewDesc: "Bất kỳ ai có đường liên kết này đều có thể xem.",
                whiteboardSharePermissionEditDesc: "Bất kỳ ai có đường liên kết này đều có thể thao tác.",
                whiteboardShareLinkLabel: "Liên kết",
                whiteboardShareCopyBtn: "Sao chép",
                whiteboardShareCopied: "Đã sao chép liên kết",
                whiteboardShareDoneBtn: "Đóng",
                startMeetingWithoutRecording: "Bắt đầu phiên họp không có ghi hình",
                startMeetingWithoutAI: "Bắt đầu cuộc họp không sử dụng AI",
                startMeetingWithoutAISummary: "Bắt đầu cuộc họp không có tóm tắt cuộc họp (AI)",
                startMeetingWithoutAILiveCaption: "Bắt đầu cuộc họp không có chức năng phụ đề (AI)",
                startMeetingWithoutRecordingAndAI: "Bắt đầu cuộc họp không có ghi hình và AI",
                changeQuantity: "Thay đổi số lượng",
                maxCamEnabled: "Số camera được bật",
                updateMaxCamSuccess: "Thay đổi số camera được bật thành công",
        },
        en: {
                period: "Validity period",
                cancelledDate: "Cancelled date",
                registerNew: "Register new",
                renew: "Renew",
                changeInfo: "Change information",
                performedBy: "Performed by",
                add: "Add",
                accessCode: "Access code",
                accessLink: "Access link",
                accessCodeFormFeedback: "6-12 alphanumeric characters",
                AccessCodeIsRequired: "Access code field is required",
                AccessCodeLength: "Your access code length must be at least 6 characters but not more than 12",
                AccessCodeRequired: "Access code  field is required",
                AccessIsDenied: "Forbidden access to this resource. Please check your permissions",
                accessPermission: "Access permission",
                account: "Account",
                accountId: "Account ID",
                accountInfo: "Account info",
                accountsSignDay: "Accounts signed contract within the day",
                action: "Action",
                actionComplete: "Complete",
                actionDelete: "Delete",
                activate: "Activate",
                activateBackupSchedule: "Activate backup schedule",
                ActivationCodeExpired: "Active Code is expired ",
                active: "Active",
                activeStatus: "Active status",
                activeSubPlans: "Active plans",
                activeSuccessful: "Active successful",
                addIpBlock: "Add ip block",
                addMeetingParticipant: "Add meeting participant",
                addMeetingParticipantSuccessful: "Added meeting participant successful",
                addNewContact: "Add new contact",
                address: "Address",
                AddressMaxLength: "Max email length is 255 characters",
                adminAccountList: "Admin account list",
                adminSearchPlaceholder: "Search by name, email, phone",
                appNameSearchPlaceholder: "Search by app name, domain",
                advancefilter: "Advanced filter",
                agree: "Agree",
                alert: "Alert",
                all: "All",
                alreadyHaveAccountQ: "Already have an account?",
                alreadySentEmailInvitation: "Invitation email already sent",
                alreadySentMeetingCancelEmail: "Meeting cancel email already sent",
                alreadySentMeetingUpdateEmail: "Already sent meeting update email",
                amountCustomerToPay: "Customer needs to pay",
                and: "and",
                ApiKeyNameyIsNull: "Api key field or api key name field is required",
                APIURLContactImport: "API of Contact:",
                ApiUrlRequired: "URL API is required",
                AppActiveRequired: "Active field is required",
                AppDomainNameRequired: "Domain Name field is required",
                application: "Application",
                appList: "App list",
                AppLogoExtRequired: "File Type field is required",
                AppLogoRequired: "Logo field  is required",
                apply: "Apply",
                appName: "App name",
                AppNameCustomerExist: "App already exists for this customer ",
                AppNameNotFound: "App is  not found ",
                AppNameRequired: "App Name field is required",
                areaFilterSelectLabel: "Sale area",
                AreaIdIsRequired: "Area Id field is required",
                AreaRequired: "Area field is required",
                attribute: "Attribute",
                backup1: "Backup",
                backupCronSchedule: "Backup cron schedule",
                backupDb: "Backup db",
                backupLocalPath: "Backup local path",
                backupOptions: "Backup options",
                BackupPolicyBadRequest: 'Backup Scheduling is invalid. You should use format "minute hour date month dayoftheweek". Example "5 1 9 4 * ?"',
                backupSourceCode: "Backup source code",
                BadRequest: "The data is invalid. Please recheck your input",
                browser: "Browser",
                business: "Business",
                cacgoicuoccuakhuvuc: "Area's Package List",
                calendar: "Calendar",
                calendarLocationName: "Location name",
                cancel: "Cancel",
                cancelled: "Cancelled",
                cancelMeeting: "Cancel meeting",
                cancelMeetingSuccessful: "Meeting cancelled",
                cancelService: "Cancel service",
                cancelServiceConfirm: "Are you sure you want to cancel the service?",
                cancelServiceSuccess: "Cancelled successfully",
                cancelThisMeetingConfirm: "Cancel this meeting?",
                cannotLeaveFieldBlank: "Cannot be blank",
                cannotGetDownloadLink: "Cannot get download link",
                downloadLinkExpired: "Download link is expired",
                capNhatKhuVuc: "Update Region",
                chairman: "Chairman",
                change: "Change",
                changePassword: "Change password",
                changeWebPort: "Change web port",
                chartLogTitle: "Device and browser warning statistics",
                chartSub1: "Device",
                chartSub2: "OS PC",
                chartSub3: "Web Browser",
                chartSub4: "Mobile Platform",
                chartView: "Chart view",
                chonGoiCuoc: "Plan selection",
                chooseContact: "Choose contact",
                chooseFromContacts: "Choose from contacts",
                faceid_not_verified: "This user does not have a FaceID or the FaceID has not been verified",
                chooseSubscription: "Choose subscription",
                expiredServce: "Your service has expired. Please contact us to renew or subscribe to a new plan.",
                chuadangkygoicuoc: "Not regis",
                clearFilter: "Clear",
                clone: "Clone",
                close: "Close",
                code: "Code",
                companyName: "Company name",
                configBackupPolicy: "Config backup policy",
                ConfigBackupPolicyInvalid: "Backup configuration is invalid ",
                ConfigFtpHostInvalid: "Config FPT field is invalid",
                ConfigIsActive: "The configuration is inactive. Please active before doing this activity",
                featureList: "Feature list",
                config: "Config",
                featureCode: "Feature code",
                featureName: "Function name",
                enableDefault: "Enable default",
                editFeature: "Edit function",
                createFeature: "Create feature",
                setting: "Setting",
                configPasswordPolicy: "Config password policy",
                confirmPassword: "Confirm password",
                ConfirmPasswordRequired: "Please enter your confirm password ",
                contact: "Contacts",
                contactFileFormatError: "Please upload a file with the same excel format and table structure as the sample file",
                contactFileSizeError: "Cannot send file larger than 1MB in size",
                contactList: "Contact list",
                ContactNameIsRequired: "Contact Name field is required",
                ContactNameMaxLength: "Max contact name length is 255 characters",
                contactSearchPlaceholder: "search by name, email, phone",
                content: "Content",
                contentCannotBeBlank: "Content cannot be blank",
                contentError: "Error content",
                ContentRequired: "Content field is required",
                copied: "Copied",
                copiedHostJoinUrl: "Copied host join URL",
                copieQRLink: "Copy the meeting link",
                copy: "Copy",
                copyLink: "Copy link",
                copyJoinUrl: "Copy join URL",
                coreDomain: "Core domain",
                coreDomainSelect: "Core domain selected",
                coreImplName: "Core platform",
                CoreImplNameIsRequired: "Core type is required to be BBB or Zoom ",
                corporation: "Corporations",
                corporations: "Corporations",
                count: "Count",
                countPackage: "and {count} other packages",
                create: "Create",
                createAccount: "Create account",
                createAccountSuccessful: "Account created successfully",
                createAdminAccount: "Create admin account",
                createAdminAccountSuccessful: "Account created successfully",
                createApiConfigSuccessful: "Create configuration successful",
                createApp: "Create application",
                createAppSuccessful: "Application created successful",
                createBy: "Create By",
                createCalendarLocationSuccessful: "Location created successfully",
                createCalendarMeeting: "Schedule a meeting",
                createContactSuccessful: "Contact created successful",
                createContentWidget: "Place this code wherever you want to add a Widget",
                createCustomer: "Create customer",
                createCustomerAdminAccount: "Create customer admin account",
                createCustomerAdminAccountSuccessful: "Account created successfully",
                createCustomerUserAccount: "Create customer user account",
                createDate: "Date created",
                createdDate: "Created date",
                createdTime: "Created date",
                createEvent: "Create event",
                createIpPolicySuccessful: "IP policy created successful",
                createMeeting: "Create meeting",
                createMeetingSuccessful: "Meeting created successful",
                createNew: "Create new",
                createNewCustomer: "Create new customer",
                createNewCustomerSuccessful: "Customer created",
                createRandomAccessCode: "Random code",
                createRegionSuccessful: "Region created successfully",
                createSaleAccount: "Create sale account",
                createSaleAccountSuccessful: "Created sale account successfully",
                createServiceAdminAccount: "Create service admin account",
                createSubPlan: "Create package",
                createSubPlanSuccessful: "Create package successful",
                errorNullSubcription: "Please select at least one feature for the subscription plan",
                createSuccessful: "Created successful",
                createWidget: "Create Widget",
                creator: "Creator",
                cronScheduleExplain: "Cron schedule explain",
                currentExpDate: "Current expiry date",
                currentPassword: "Current password",
                CusSubsPlanToRenewIsNotFound: "Customer's subscription plan is invalid. Please subscribe to a valid service plan to use this product",
                customer: "Customer",
                customerAdminAccount: "Customer admin accounts",
                customerAdminAccountList: "Customer admin accounts",
                customerAutofillPlaceholder: "search by code, name, email or phone number",
                CustomerDuplicateCode: "Customer code already existed. Try another",
                CustomerDuplicateIdCode: "Personal identification number already existed. Try another",
                CustomerDuplicatePhoneNumber: "The phone number is taken. Try another",
                CustomerDuplicateTaxCode: "Tax code already existed. Try another ",
                customerId: "Customer ID",
                CustomerIdIsRequired: "Customer id field is required",
                customerIdShort: "Customer ID",
                customerInfo: "Customer info",
                CustomerIsExisting: "The customer is taken. Try another",
                customerList: "Customer list",
                customerName: "Customer name",
                CustomerNameIsRequired: "The full name field is required",
                CustomerNameMaxLength: "Max  full name length is 255 characters",
                customerNameShort: "Customer name",
                CustomerNotMatchForRenewOrUpgrade: "Not found the customer's subscription plan to upgrade",
                customerSearchPlaceholder: "code, name, email or phone number",
                customerStatusActive: "Active",
                customerStatusCancelled: "Cancelled",
                customerStatusInactive: "Inactive",
                inActive: "Inactive",
                CustomerSubscriptionIsExpired: "Subscription plan has expired. Please subscribe a new service plan to use this product ",
                CustomerSubscriptionNotFound: "Please subscribe a service plan to use this product",
                customerType: "Customer type",
                customerSource: "Customer source",
                customerTypeBusiness: "Busines",
                customerTypePersonal: "Personal",
                customerUserAccountList: "Customer user accounts",
                currentPackage: "You are using the {package} package:",
                packageLimit: "You can host meetings for up to {hour} with a maximum of {person} participants.",
                storageNotEnough: "Your remaining storage is {storage}MB. Recording a meeting requires at least 200MB of free space. Please upgrade your package or free up storage to use the recording feature.",
                danhSachGoiCuoc: "Package list",
                dashboardChartTitle: "TOTAL NUMBER OF MEETINGS AND PARTICIPANTS",
                date: "Date",
                time: "Time",
                datetime: "Datetime",
                days: "Days",
                decree: "Decree",
                here: "here",
                remainingDays: "Remaining days",
                defaultAccount: "Default account",
                delete: "Delete",
                deleteAccount: "Delete account",
                deleteRecording: "Delete recording",
                deleteAccountConfirmation: 'Delete "{account}"?',
                deleteAccountSuccess: "Account deleted",
                deleteAll: "Delete all",
                deleteAllRecordings: "Delete all recordings",
                deleteAllData: "Delete all data",
                deleteAllContactsConfirm: "Do you want to delete all contacts",
                DeleteAllCustomerUserViewSuccessful: "Your account has been successfully deleted",
                deleteAllViewer: "Delete all Viewers",
                deleteAllViewerConfirmation: "Are you sure you want to delete all Viewers?",
                deleteAllViewerSuccess: "Delete all viewer accounts successfully",
                deleteBy: "Delete By",
                deleteContactSuccessful: "Contact deleted",
                deleteRegionSuccessful: "Region delete",
                deleteFunctionSuccessful: "Function delete successful ",
                deleteCustomer: "Delete customer",
                deleteCustomerConfirmation: 'Delete "{name}"?',
                deleteCustomerSuccess: "Customer deleted",
                deleteDate: "Date deleted",
                deleteEventConfirm: `Delete "{subject}"?`,
                deleteEventSuccessful: "Event deleted",
                deleteIpBlockConfirm: "Delete ip block confirm",
                deleteIpBlockSuccess: "Delete ip block success",
                deleteLogConfirm: "Delete this record? (ID: {id})",
                deleteLogSuccessful: "Delete log successful",
                deleteMeeting: "Delete meeting",
                deleteMeetingSuccessful: "Meeting deleted",
                deleteRecordedSuccessful: "Recorded deleted",
                deleteRecordedSuccessfulAll: "All recorded deleted",
                deleteRecordConfirmation2: `Delete "{name}"? (ID: {id})?`,
                deleteRecordConfirmation: "Delete {name}? (ID: {id})?",
                deleteSubPlanConfirm: `Delete plan "{name}"? (ID: {id})`,
                deleteRegionConfirm: `Delete region "{name}"? (ID: {id})`,
                deleteFunctionConfirm: `Delete function "{name}"? (ID: {id})`,
                deleteSubPlanSuccessful: "Successfully deleted",
                deleteSuccessful: "Delete successful",
                deleteThisMeetingConfirm: "Delete this meeting?",
                deleteThisRecordedConfirm: "Delete this recorded?",
                deleteThisRecordedConfirmByType: `Delete this recorded?`,
                deleteAllRecordedConfirm: "Delete all recorded?",
                deleteYourAccount: "Are you sure you want to delete your account ?",
                demo: "Demo",
                description: "Description",
                defaultTurnOn: "Default turn on",
                deselectAll: "Deselect all",
                details: "Details",
                device: "Device",
                disagree: "Disagree",
                displayActiveSubConcurrentMeetings: "{count} concurrent meetings",
                displayActiveSubMaxMeetingLength: "{count} minutes per meeting",
                displayActiveSubMaxParticipants: "{count} participants per meeting",
                displayActiveSubMaxParticipantsPool: "Max {count} participants",
                displayActiveSubMeetingCount: "{count} meetings per month",
                displayActiveSubPrice: "{price} VND per {months} month(s)",
                displayStorageUsed: "{used}/{total} GB used",
                displayQuotaUsedAndTotal: "{used}/{total} Minutes used",
                displayQuotaUsed: "{used} Minutes used",
                documentNumber: "Document number",
                documentNumberInvalid: "Invalid document number",
                documentType: "Document type",
                domain: "Domain",
                done: "End",
                dontHaveAccount: "Don't have an account?",
                download: "Download",
                downloadApp: "Download app",
                downloadSampleFile: "Download sample file",
                edit: "Edit",
                editEvent: "Edit",
                editInfo: "Edit info",
                editMeeting: "Edit",
                editRegion: "Edit Region",
                effDate: "Effective date",
                emailContent: "Content",
                EmailExist: "The email address has already been used.",
                EmailExist1: "The email address has already been used.",
                EmailInvalid: "Email is  invalid",
                EmailMaxLength: "Max email length is 250 characters",
                emailPlaceHolder: "Enter email",
                EmailRequired: "Email field is required",
                emailSubject: "Subject",
                emailTemplate: "Email template",
                emailTypeCancelMeeting: "Meeting cancelled",
                emailTypeInviteMeeting: "Meeting invitation",
                emailTypeUpdateMeeting: "Meeting updated",
                enableAutomaticMeetingRecording: "Enable automatic meeting recording",
                enableMicro: "Enable micro",
                enableParticipationBeforeHost: "Allow participation before host",
                enableTakingNote: "Enable taking note",
                enableToggleMeetingRecording: "Enable toggle meeting recording",
                enableVoiceText: "Use the meeting summary function",
                enableAutoVoiceText: "Enable auto voice text",
                endDate: "End date",
                endMeeting: "End meeting",
                endMeetingWarning: `End meeting "{name}" (ID: {id})?`,
                endThisMeetingWarning: "End this meeting?",
                enterAccessCode: "Enter access code",
                enterprise: "Enterprise",
                featureConfig: "Feature config",
                enterInfrastructureID: "Enter infrastructure ID",
                errorRow: "error row {row}, error value {value}",
                errorStat: "Error statistics",
                eventAllDay: "All day",
                eventEndTime: "End",
                eventInvitees: "Invitees",
                eventParticipants: "Participants",
                eventPreparation: "Preparation",
                eventStartTime: "Start",
                eventStatusCancelled: "Cancelled",
                eventStatusPending: "Pending",
                evict: "Evict",
                expDate: "Expiry date",
                expDateAfterRenew: "Expiry date after renew",
                expired: "Expired",
                expireDate: "Expire Date",
                expireYourPackage: "Your package expires",
                export: "Export Excel",
                contentMeeting: "Export Content Room",
                aiSummaryDisclaimer: "The content generated by AI may be incomplete or inaccurate. Please verify the meeting content to ensure accuracy!",
                exportContent: "Export",
                generalContent: "Meeting Minutes",
                summaryOfSTT: "Summary by STT",
                summaryOfTimeline: "Summary by Timeline",
                exportLog: "Export log",
                exportParticipants: "Export Participants",
                exportSumary: "Export Sumary",
                faceChosePlaceholder: "Can select multiple photos at once",
                faceIdIconSub: "Face recognition image available",
                faceidStatus: "Enable/disable FaceID",
                faceIdSub: "Only people with face image information will be added to the meeting",
                faceImage: "Face Image",
                faceImageTitle1: "Select images for user",
                faceImageTitle2: "The image name matches the corresponding code of the user in the phonebook",
                file_not_found: "File is not found ",
                footerAttribution: "Product of VNPT-IT",
                forgotPassword: "Forgot password",
                forgotPasswordQMark: "Forgot password?",
                FormatEmailInvalid: "Invalid format email",
                FormatInvalidName: "The name cannot be empty or contain the characters `!@#$%^&*~{}?",
                FormatPhoneInvalid: "Invalid format phone",
                from: "From",
                fromDate: "From date",
                khoangthoigian: "Period of time",
                fullName: "Full name",
                FullNameRequired: "Full name field is required",
                gmTokenConfig: "Active GMToken",
                guideToken: "View guide token",
                headerMenuAdmin: "Administration",
                hintUsernameOrEmail: "Username or email",
                hostJoinUrl: "Host/Admin Link",
                hours: "hours",
                with: "with",
                IdRequired: "Id field is required",
                importContactFromFile: "Import from file",
                importContactOption0: "Import from file",
                importContactOption1: "Import from URL API",
                importContactOption: "Change option:",
                importContactsFromFileSuccessful: "Imported successful",
                ImportContactSuccessful: "Contacts has been imported successfully",
                vuilongchonFileImport: "Please select file to import",
                importFromFile: "Import from file",
                importUserFromFile: "Import user accounts from file",
                inactiveSubPlans: "Inactive plans",
                incorrect_file_format: "File format is not supported",
                includespacename: "Username must not contain spaces or special characters",
                specailRegex: "no special characters allowed",
                recheck: "please check again",
                recheckExcel: "Please check your file: ",
                duplicateusername: "Duplicate username: ",
                duplicateemail: "Duplicate:",
                at: "at",
                row: "row",
                uploadokbut: "Import data has error:",
                recheckfile: "Please check the data in the file and try again!",
                includespaceemail: "Email information must not contain spaces",
                individual: "Individual",
                inprogress: "Inprogress",
                InternalServerError: "500 Internal Server Error",
                InvalidAccessCode: "Access code  is invalid ",
                InvalidActivationCode: "Active Code is invalid ",
                InvalidAreaId: "Area Id is  invalid ",
                InvalidCas: "Unable to sign in with SSO. Please recheck username/password you registered with SSO ",
                InvalidContactCode: "ContactCode is null or invalid",
                InvalidContactId: "Contact is not found ",
                InvalidCustomer: "Customer is not found ",
                InvalidCustomerId: "Customer is not found ",
                InvalidCustomerName: "Field CustomerName must contain only alphabets",
                InvalidCustomerSubscriptionId: "Customer's subscription plan is not found. Please subscribe to a service plan to use this product",
                invalidDateRange: "Invalid date range",
                invalidEmail: "Invalid email",
                InvalidIPAddress: "Ip address is invalid ",
                InvalidLogin: "Username or Password is invalid ",
                InvalidLogo: 'Logo format is invalid.  Please select an alternative image source file, such as ".jpg, .jpeg, .png"',
                invalidMeetingDurationOrExceededLimit: "Invalid meeting duration or exceeded limit",
                InvalidMeetingId: "The meeting is not found ",
                invalidMeetingOperatorOrParticipantEmail: "Invalid operator/participant email",
                InvalidMeetingRole: 'Role field is invalid. Please use "PARTICIPANT" or "OPERATOR" role instead',
                invalidMeetingStartDatetime: "Invalid meeting start date/time",
                InvalidMeetingStatus: 'Status of meeting is invalid.  Please use "pending" or "inprogress" or "end" instead',
                InvalidParamInput: "Please upload an valid file format. Referecing to file upload sample to get the right format. ",
                InvalidParticipantName: "Error: Invalid Participant Name",
                invalidPasswordPattern: "Invalid password pattern",
                invalidPhoneFormat: "Invalid phone number format",
                InvalidRequest: "the data is invalid due to validation restrictions, please recheck your input",
                invalidSecretKey: "Invalid secret key",
                InvalidSecretKey: "Secret key is invalid",
                InvalidSubscriptionPlan: "Plan is not found ",
                invalidTaxCode: "Invalid tax code",
                InvalidWebhookConfigureId: "Webhook configuration is invalid",
                invnpt: "In VNPT",
                IPAddressIsRequired: "Ip Address field is required",
                IPAddressNULL: "Id Address field must not be null ",
                ipBlacklist: "IP blacklist",
                ipBlockList: "Ip block list",
                issueDate: "Issue date",
                issuePlace: "Issue place",
                it: "IT",
                itemsPerPage: "Items per page",
                joinByFaceId: "Join by Face Id",
                joinMeeting: "Join meeting",
                joinMeetingBrowser: "Join Meeting",
                inputInfoMeeting: "Input meeting information",
                joinMeetingDesc: "Please enter join code and access code to continue",
                joinCode: "Join code",
                joinCodePlaceHolder: "Enter join code (e.g. 123456789)",
                joinWithAnotherCode: "Join with another code",
                joinMeetingOperator: "You will join the meeting as",
                joinMeetingApp: "Open App",
                keyword: "Keyword",
                keywordMeetings: "Search by ID, Name",
                khongxacdinh: "Unknow error",
                lastUpdate: "Last update",
                leaveMeeting: "Leave",
                linksAndAccessCodes: "Join info",
                loadingData: "Loading data...",
                LocalPathInvalid: "Local path field is invalid",
                LocalPathIsRequired: "Local path field is required",
                location: "Location",
                LockedOutDuration: "Lock Duration is range in 1 - 1440 minutes",
                login: "Login",
                LoginLockoutEnabled: "Your account will be temporarily locked for {m} minutes after {i} failed login attempt.",
                loginPageTitle: "Login",
                loginSME: "Login by IDP",
                loginVnptSso: "Login with VNPT",
                logout: "Logout",
                logPolicy: "Log policy",
                maKhuVuc: "Code",
                manageFunction: "Manage function",
                manageAccount: "Manage account",
                manageConfigToken: "Manager config token",
                configurations: "configurations",
                manageConfigulation: "Configulation management",
                manageGMToken: "Manage tokens",
                manageGMTokenTitle: "Token List",
                manageMeetings: "Manage meetings",
                sourceMeetingTooltip: "Source meeting: {id}",
                manageServices: "Manage services",
                manageStorage: "Manage storage",
                freeStorage: "Free storage {storage} GB",
                freeQuota: "{remaining} minutes remaining",
                manageRecordings: "Manage Recordings",
                maximum: "Maximum",
                maximumLengthOfOneMeeting: "Maximum length of one meeting",
                MaximumLengthOfOneMeetingIsRequired: "Duration of meeting is required",
                MaximumLengthOfOneMeetingLength: "Meeting duration is range in 30 - 1440 ",
                maximumNumberOfParticipantsInMeeting: "Maximum number of meeting participants",
                managementType: "Management Type",
                concurrentParticipantPoolOption: "Pool participants",
                maxParticipantPoolRequired: "Total concurrent participants is required",
                participantsCountExceededLimit: "Maximum number of participants exceeds the limit ({max})",
                MaximumNumberOfParticipantsIsRequired: "Number of participants is required",
                MaximumNumberOfParticipantsLengh: "Number of participants is range 1:1000",
                maxMeetingParticipantsExceeded: "Max no. of participants exceeded!",
                limitExceededTitle: "Package limit exceeded!",
                poolLimitExceededDesc: "The current total number of participants has exceeded the package limit <strong>({total}/{limit} participants)</strong>. Please reduce the number of participants or end other ongoing meetings.",
                createMeetingCoreFailedTitle: "Core meeting creation failed!",
                tokenInvalidTitle: "Invalid session!",
                forbiddenTitle: "Access denied!",
                internalServerErrorTitle: "Unable to process request!",
                meetingNotFoundTitle: "Meeting not found!",
                customerSubscriptionIsExpiredTitle: "Subscription expired!",
                whiteboardInUseByOtherMeetingTitle: "Whiteboard in use!",
                lockTimeoutTitle: "Request timeout!",
                errorCodeLabel: "Code",
                meetingStatusNotPendingOrEndTitle: "Invalid meeting status!",
                customerSubscriptionNotFoundTitle: "Subscription not found!",
                notFoundPlanInCustomerSubscriptionTitle: "Invalid subscription plan!",
                maxParticipant: "The largest number of participants",
                media: "Media",
                meeting: "Meeting",
                MeetingAccessDenied: "Forbidden access to this resource. Please check your permissions",
                meetingActualTime: "Actual",
                meetingChatNotAllow: "Chat not allowed",
                meetingRecordingDeleted: "Meeting recording deleted",
                recodingDeleted: "Recording deleted",
                meetingConfig: "Settings",
                meetingCount: "Meeting count",
                MeetingCountDailyIsExceeded: "The number of meetings per day exceeded the limit of your plan",
                meetingCountDetails: "Meeting count details",
                meetingCountTotal: "Meeting count total",
                meetingDate: "Date",
                meetingDetailReport: "detailed meeting report",
                meetingDetailReportSearchPlaceholder: "Search by meeting name, creator",
                meetingDetails: "Meeting details",
                meetingDuration: "Duration",
                meetingDurationFormFeedback: "Minimum 15 minutes, maximum",
                meetingEndedMsg: "Meeting already ended",
                meetingHasRecording: "Recorded meeting",
                meetingId: "Meeting ID",
                meetingIDCodeCustomer: "Search by meeting name, Id, Customer",
                MeetingIdIsRequired: "Meeting Id field is required",
                meetingInfo: "Meeting info",
                meetingList: "Meetings",
                meetingLocation: "Meeting location",
                meetingMuteOnStart: "Mute on start",
                meetingName: "Meeting name",
                meetingNamePlaceHolder: "Enter meeting title",
                meetingType: "Meeting type",
                MeetingNameIsRequired: "Meeting title field is required",
                meetingNoRecordedFile: "No recorded file",
                meetingProgressRecorded: "Recording in progress",
                meetingCode: "Meeting code",
                meetingCodePlaceHolder: "Enter meeting code",
                MeetingNotFound: "The meeting is not found ",
                meetingOperator: "Operator",
                meetingOperatorBadge: "Operator",
                meetingParticipant: "Meeting participant",
                meetingParticipantsJoined: "In meeting ({count})",
                notEnoughStorageToRecord: "Not enough storage space to record",
                notEnoughAiFeatureLimit: "Not enough limit to use AI feature",
                meetingParticipantsList: "Participants",
                meetingParticipantsMaxCount: "Max {count}",
                meetingParticipantsNotJoined: "Not in meeting ({count})",
                meetingPendingMsg: "meeting has not started",
                meetingPrivateChatAllow: "Private chat allowed",
                meetingPublicChatAllow: "Public chat allowed",
                meetingRestartMsg: "You can restart the meeting",
                meetingScheduledTime: "Scheduled",
                meetingSearchPlaceholder: "Search by code, customer name",
                MeetingSecretKeyRequired: "Secret Key field is required",
                meetingShareCamera: "Camera on",
                meetingsListToday: "Meetings list today",
                meetingStatusCancelled: "Cancelled",
                meetingStatusEnded: "Ended",
                MeetingStatusEnded: "The meeting has been ended",
                meetingStatusInProgress: "In progress",
                MeetingStatusInvalid: "Status of the meeting is invalid ",
                meetingStatusPending: "Pending",
                MeetingStatusPending: "The meeting has not started yet ",
                meetingSumary: "Sumary",
                activeGMToken: "Activate token",
                both: "Both",
                meetingStart: "Meeting start",
                meetingReopen: "Reopen meeting",
                meetingTableActualDateTimeTitleAttr: "Start: {start}\nEnd: {end}",
                meetingTableScheduledDateTimeTitleAttr: "Scheduled start: {start}\nScheduled end: {end}",
                meetingTurnOffCamera: "Camera off",
                meetingTypeClosed: "Private meeting",
                meetingTypeOpen: "Public meeting",
                mini: "Minimize",
                more: "More actions",
                MinimumNumOfParticipants: "The number of participants must be at least one",
                MinScheduleDuration: "Duration must be at least 15 minutes",
                minutes: "Minutes",
                ModelNotFound: "Data is not found ",
                months: "Months",
                mustChangeDefaultPassword: "Must change default password",
                NameMaxLength: "Max full name length is 100 characters",
                namePlaceHolder: "Enter fullname",
                accessCodePlaceHolder: "Enter access code",
                nameUnit: "Name Unit",
                nameFeatureRequired: "Function name field is required",
                descriptionFeatureRequired: "Function description field is required",
                nearExpired: "Near Expired",
                net: "NET",
                newAccountsDay: "New accounts of the day",
                newApiConfig: "Create new configuration",
                newMeetingDefaultName: "Meeting on ",
                newPassword: "New password",
                NewPasswordInvalid: "Currentpassword and new password should not be same",
                NewPasswordRequired: "Required NewPasword Field",
                newRegion: "New area",
                no: "No",
                noActiveSub: "No active subscriptions",
                noData: "No data",
                noEvent: "No events",
                noFoundSearch: "No result is found..",
                noRegisteredService: "No registered service",
                NotAllowedToJoinMeeting: "The max of number of participants in the meeting reached. You can not joined the meeting. ",
                note: "Note",
                attention: "Attention",
                deleteRecordingWarning: "Once deleted, the data cannot be restored. Please download the recordings of important meetings to your device before performing this action!",
                NoActiveApiConfigForPlan: "No active API configuration for this plan",
                notGetVerificationEmailYetC: "If you did not receive the email",
                notSendEmailInvitation: "Invitation email not sent",
                notSendMeetingCancelEmail: "Meeting cancel email not sent",
                notSendMeetingUpdateEmail: "Not send meeting update email",
                numberDaysKeepLog: "Days to keep log",
                NumberOfConcurrentMeetings: "Number of concurrent meetings is range in 1:100",
                numberOfConcurrentMeetings: "Number of concurrent meetings",
                ConcurrentMeetings: "Concurrent meetings",
                NumberOfConcurrentMeetingsIsRequired: "Number of concurrent meetings is required",
                NumberOfConcurrentMeetingsLength: "Number of ooncurrent meetings is range 1:100",
                NumberOfDaysUsage: "The validity period for plan is range in 1-36 days",
                NumberOfDaysUsageIsRequired: "The validity period for plan is required",
                NumberOfMeetingsPerMonth: "Number of meetings per month is range in 1-10000",
                numberOfMeetingsPerMonth: "Number of meetings per month",
                NumberOfMeetingsPerMonthIsRequired: "Number of meetings per month is required",
                NumberOfParticipantIsExceeded: "The number of participants in the meeting exceeded the limit of your plan ",
                numCameraOn: "Camera on",
                numMeeting: "Number of meetings",
                numOfActualParticipants: "Num of actual participants",
                numOfParticipants: "Maximum number of participants",
                numVoiceOn: "Voice on",
                official: "Official",
                ok: "Ok",
                OldPasswordInvalid: "Current password is invalid",
                OnlyDelMeetingInPendingStatus: "Unable to delete occurrence meeting",
                onlyShowCameraForOperator: "Only show camera for operator",
                onOff: "On/Off",
                openGmail: "Open Gmail",
                openInApp: "Open in app",
                openInBrowser: "Open in browser",
                openOutlook: "Open Outlook",
                or: "Or",
                organ: "State Agencies",
                os: "OS",
                other: "Other",
                outside: "Besides VNPT",
                overview: "Overview",
                ownedBy: "Owned by",
                packageStatus: "Package Status",
                packageType: "Package type",
                PageRangeInteger: "Page is range in 1 - 214748364",
                PageRequired: "Page field is required",
                PageSizeRange: "Page size is range in 10-1000",
                PageSizeRequired: "Page size field is required",
                ParticipanNameMaxLength: "Max participant name length is 255 characters",
                participantJoinUrl: "Participant Link",
                ParticipantNameIsRequired: "Participant name field is required",
                ParticipantRequired: "Participant field is required",
                password: "Password",
                passwordChangedSuccessful: "Password changed successful",
                PasswordContainMailPrefix: "To ensure security, the password must not contain parts of the email!",
                PasswordContainsDatePattern: "To ensure information security, the password must not contain birth date information!",
                PasswordContainsDisallowedPatterns: "To ensure information security, the password must not contain content such as: the letter sequence ABCD, 1234, 2345, 3456, ...",
                PasswordContainsRepeatingCharacters: "To ensure information security, the password must not contain 3 consecutive identical characters!",
                PasswordContainsWhitespace: "The password must not contain spaces!",
                PasswordContainUsername: "To ensure security, the password must not contain parts of the username!",
                passwordDescription: "Password description",
                passwordFormat: "Password must be at least 8 characters including numbers, lowercase letters, uppercase letters and special characters.",
                passwordhasbeenusedbefore: "The new password cannot be the same as the current password",
                PasswordInWordlist: "To ensure security, do not use easily guessed passwords!",
                PasswordLength: "Your password's length must be at least 6 characters but not more than 32",
                passwordLockedOut: "Password locked out",
                passwordLockedOutDuration: "Password locked out duration",
                PasswordMaxLength: "Max Password length is 32 characters",
                passwordMaxLength: "Password max length",
                passwordMinLength: "Password min length",
                PasswordNotMatch: "Your confirm password does not match the password",
                passwordPattern: "Password pattern",
                passwordPolicy: "Password policy",
                PasswordPolicyInvalid: "Max password length must be greater than min password length ",
                PasswordPolicyLength: "The password's length must be at least 6 characters but not more than 30!",
                PasswordPolicyRegex: "Password must be at least 8 characters including numbers, lowercase letters, uppercase letters and special characters!",
                PasswordRequired: "Password field  is required",
                passwordResetSuccessful: "Password reset successful",
                setupConfigSuccessful: "Setup configuration successful",
                passwordsNotMatch: "Passwords not match",
                passwordValidationFailedMessage: "Password validation failed message",
                passwordValidityPeriod: "Password validity period",
                PasswordValidityPeriod: "Valid date range is 1 - 3650 ",
                pending: "Waiting",
                personal: "Personal",
                PhoneMaxLength: "Max phone number is 50 numbers",
                phoneNumber: "Phone number",
                tongsocuochop: "Number of meetings",
                PhoneNumberMinLength: "Min phone number length is 10 characters",
                PhoneNumberRequired: "Phone number field is required",
                phonePlaceHolder: "Enter phone number",
                planExpireGt2Months: "Expires in > 2 months",
                planExpireLt2Months: "Expires in < 2 months",
                pleaseChoose: "Please Choose",
                pleaseEnterDocumentExpDate: "Please enter document expiry date",
                pleaseEnterDocumentIssueDate: "Please enter document issue date",
                pleaseSelectMeetingStartDate: "Please select meeting start date",
                pleaseSelectMeetingStartDatetime: "Please select meeting start time",
                pleaseSelectValidDate: "Please select a valid date",
                portalHome: "Home Page",
                PortLength: "Port is range in 0-65535",
                PortPolicyError: "Your update failed",
                private: "Private",
                privateSub1: "Meeting information will be sent separately to those on the list, only these people are allowed to participate in the meeting.",
                province: "Province/City",
                public: "Public",
                QRCodeText: "Participation QR Code",
                otherInfo: "Other Information",
                securityCodeLabel: "Security Code",
                joinLink9DigitsLabel: "Join Link with 9-digit code",
                reopenMeetingLink: "Link to reopen meeting room",
                reopenMeetingTooltip: "You can reopen the meeting session after it has ended.\nPeople with the join link can participate again.",
                reopenMeetingHint: "This link allows the host to restore an ended meeting session and let participants access it again.",
                reopenMeetingSecurityWarning: "For security reasons, absolutely do not share this link with anyone!",
                regionAdminList: "Business Areas",
                regionCode: "Region Code",
                regionName: "Region Name",
                register: "Register",
                registerAccount: "Register",
                registerAccountSubtitle: "Free meetings and conferences",
                registerAccountSubtitle2: "of VNPT GoMeet product",
                registerConfirmCorrectInfo: "Please confirm the information above is correct",
                registerService: "Register service",
                registerServiceInfo: "Service info",
                registerServiceSuccessful: "Register service successful",
                reload: "Reload",
                reNew: "Renew",
                renewConfirmCorrectInfo: "Please confirm the information above is correct",
                renewService: "Renew service",
                renewServiceSuccess: "Renewed successfully",
                settingServiceSuccess: "Update setting successfully ",
                meetingConcurrentParticipantsLimit: "Number of participant",
                meetingParticipants: "Participants in meeting",
                participants: "participants",
                settingService: "Setting package",
                settingQuota: "Meetings, participants",
                maxParticipantPool: "Total concurrent participants (Pool)",
                totalParticipantPool: "Total participants",
                recordingStorageNotice: "You cannot use the recording feature if the remaining storage is less than 200MB",
                meetingNotRecordable: "this meeting cannot be recorded",
                storageCleanupPrompt: "Please delete some old recordings to continue using this feature. View and manage your storage",
                quotaRenewPrompt: "You can upgrade your plan to purchase additional AI storage. If you do not upgrade, your quota will be automatically reset on {date}.",
                recordingStorageRequirement: "At least 200MB of storage is required for recording. Your available storage is {storage}, should",
                quotaAIBelow10Percent: "AI usage quota is below 10%, so this meeting cannot use AI features",
                quotaTotal: "AI quota",
                aiQuotaUnlimited: "Quota: Unlimited",
                recordingRetentionNotice: "Each recording is stored for a maximum of 90 days",
                report: "Reports",
                reportNumMeeting: "Report the number of meeting",
                required: "Required",
                resendVerificationEmail: "Resend verification email",
                resetAdminAccountPassword: "Reset admin account password",
                resetPassword: "Reset password",
                restrictCustomer: "Restrict/object",
                restrictCustomerConfirmation: 'Withdrawing consent will result in VNPT GoMeet ceasing the processing of personal data and locking the account for customer "{name}". Are you sure you want to perform this action?',
                resultCount: "Found {count} results",
                role: "Role",
                roleAdmin: "Admin",
                roleUser: "User",
                saleAccount: "Sale accounts",
                saleAccountList: "Sale accounts list",
                TTKD: "TTKD",
                ttkd2Cap: "TTKD (2 levels)",
                saleArea1: "Sale area",
                saleArea2: "Sale area",
                saleArea: "Sale area",
                save: "Save",
                saveChanges: "Save changes",
                saveConfigToken: "Save config token",
                saveSettingsSuccessful: "Save settings successful",
                ScheduleDurationIsRequired: "Duration field is required",
                ScheduleStartTimeIsRequired: "Start time field is required",
                search: "Search",
                SecretKeyExpired: "Secret key is expired",
                selectAll: "Select all",
                selectedWithCount: "Selected ({count})",
                selectedPackageCount: "Package ({count})",
                selectedWithCountRegis: "Registered package ({count})",
                selectEffDate: "Select effective date",
                selectExpDate: "Select expiration date",
                selectRangeDate: "Start date - End date",
                sendEmail: "Send email",
                sendEmailAndSms: "Send email and SMS",
                sendEmailInvitation2: "Send invitation email",
                sendEmailInvitation: "Send invitation email",
                sendEmailInvitationConfirm2: "Send invitation email to {email}?",
                sendEmailInvitationConfirm: "Send invitation email?",
                sendEmailInvitationSuccessful: "Invitation email sent!",
                sendEmailInvitationToAll: "Send invitation email to all participants",
                sendEmailSuccessful: "Sent email successfully",
                sendMeetingCancelEmail: "Send meeting cancel email",
                sendMeetingCancelEmailSuccessful: "Meeting cancel email sent!",
                sendMeetingCancelEmailToAll: "Send meeting cancel email to everyone",
                sendMeetingUpdateEmail: "Send meeting update email",
                sendMeetingUpdateEmailSuccessful: "Send meeting update email successful",
                sendMeetingUpdateEmailToAll: "Send meeting update email to all participants",
                sendServiceRenewReminderEmail: "Send service renew reminder email",
                sendServiceRenewReminderEmailConfirm: "Send service renew reminder email?",
                sendServiceRenewReminderEmailSuccessful: "Reminder email sent!",
                sendSms: "Send SMS",
                fixed: "Fixed",
                session: "Session",
                concurrentMeeting: "Concurrent Meeting",
                sendSmsInvitation2: "Send invitation SMS",
                sendSmsInvitation: "Send invitation SMS",
                sendSmsInvitationConfirm: "Send invitation SMS to {phone}?",
                sendSmsInvitationSuccessful: "Invitation SMS sent to {phone}",
                sendSmsSuccessful: "Sent SMS successfully",
                serviceAdminAccount: "Service admin accounts",
                serviceAdminAccountList: "Service admin accounts",
                serviceInfo: "Service info",
                servicePrice: "Service price",
                serviceRegisterHistory: "Service register history",
                serviceStartDate: "Service start date",
                settings: "Settings",
                SigninCas_Service_Require: "Service field is required",
                SigninCas_Ticket_Require: "Ticket field is required ",
                signUpIAgreeWith: "I have read and agree with VNPT about",
                enterAccountInformation: "Account information",
                signUpPrivacyPolicy: "Privacy Policy",
                personalDataProtectionPolicy: "Personal Data Protection Policy",
                productVnptGoMeet: "of VNPT GoMeet product",
                byJoiningMeetingYouAccept: "By joining the meeting, you agree to the",
                signupSuccessful: "Account created successful",
                signupSuccessfulSubtitle: "Account created successful. Login to your account to start experiencing our services.",
                signUpTermOfUse: "Terms of Service",
                show: "Show",
                smartVoiceToken: "Smart Voice",
                smartVoiceTokensTitle: "Manager SmartVoice",
                smartVoiceTokenSystem: "SmartVoice",
                viewRecordingAudioWithSize: "View recording audio (MP3, {size})",
                viewRecordingVideoWithSize: "View recording video ({size})",
                recordingContent: "Recording content",
                start: "Start",
                startDate: "Start date",
                StartMeetingExceed: "The number of concurrent meetings exceeded the limit of your plan",
                startMeetingWarning: "Please do not close the browser while the meeting is in progress",
                startNewMeeting: "Start an instant meeting",
                startMeetingWithoutRecord: "Start a meeting without recording",
                startMeetingNoRecord: "Start an instant meeting no recording",
                StartTimeIsRequired: "Start time field is required",
                status: "Status",
                stayLoggedIn: "Stay logged in",
                storage: "Storage",
                capacity: "Capacity",
                extraCapacity: "Extra Capacity",
                storageType: "Capacity type",
                capacitySubscriptions: "Capacity subscription",
                currentExtraCapacity: "Current additional capacity",
                purchaseExtraCapacity: "Purchase additional capacity",
                totalCapacityAfterPurchase: "Total capacity after purchase",
                usedStorageSize: "Storage used",
                storageExpiredDay: "For each content, the system only stores a maximum of {days} days",
                storageQuotaReset: "The AI quota will be reset on {date}",
                storageTotal: "Total storage",
                storageAccount: "Storage",
                storageCapacity: "Storage capacity",
                storageFullAlert: "Storage is full ({used} / {total} MB)",
                storageGb: "Storage (GB)",
                storageHistory: "Storage history",
                storageInfo: "Storage info",
                storeBothLocalAndFtp: "Store both local and ftp",
                storeLocal: "Store local",
                storeViaFtp: "Store via ftp",
                subCreatedDate: "Registered date",
                SubcriptionPlanNameMaxLength: "Max plan name is 255 characters",
                SubcriptionPlanNameRequired: "Plan name field is required",
                SubcriptionPlanPackageTypeIsRequired: "Plan type field is required",
                SubcriptionPlanPriceIsRequired: "Price of plan is required",
                SubjectMaxLength: "Max subject length is 255 characters",
                joinOnBrowser: "Join on browser",
                SubjectRequired: "Subject field is required",
                subPlanCode: "Package Code",
                subPlanList: "Packages list",
                subPlanName: "Package name",
                subscriptionInfo: "Subscription info",
                subscriptionLength: "Validity period",
                subscriptionPlan: "Subscription plan",
                SubscriptionPlanIdIsRequired: "Plan Id field is required",
                subscriptionStatusFilterSelectLabel: "Expires",
                subscriptionToRegister: "Subscription to register",
                subscriptionToUpgradeTo: "Subscription to upgrade to",
                success: "Success",
                summary: "Summary",
                transcript: "Transcript",
                summaryBySTT: "Summary from Transcript",
                summaryByTime: "Summary from Timeline",
                summaryOfAllUser: "Summary of users",
                systemLogs: "System logs",
                tableView: "Table view",
                taxCode: "Tax code",
                tdagency: "TD Agency",
                TemplateNotFound: "Email template is not found ",
                tenKhuVuc: "Name",
                test: "Test",
                testing: "Testing",
                themGoiCuoc: "Add package",
                themKhuVuc: "Add area",
                thisWeek: "This week",
                thongtinkhuvuc: "Information",
                timeEndValid: "Invalid end time",
                title: "Title",
                to: "To",
                toDate: "To date",
                TokenAPIContactImport: "Bearer Token:",
                tokenInfo: "Token info",
                TokenInValid: "Bearer Token is null or invalid",
                TokenInvalid: "Your session has expired. Please log in again",
                TokenRequired: "Bearer Token is null or invalid",
                totalCancelledMeetings: "Cancelled meetings",
                totalCustomerAccounts: "Customer accounts",
                totalCustomers: "Customers",
                totalEndedMeetings: "Ended meetings",
                totalInprogressMeetings: "Meetings in progress",
                totalMeeting: "Total meetings",
                totalMeetings: "Meetings",
                totalPackages: "Subscription packages",
                totalPendingMeetings: "Pending meetings",
                trial: "Trial",
                tukhoatimkiem: "Enter string to search",
                inputNameRegion: "Enter name region",
                type: "Type",
                typeError: "Error type",
                TypeForm: "Type meeting",
                UnableToDelete: "Data cannot be deleted because it is associated with other data",
                UnableToDeleteAcc: "Account cannot be deleted because it is associated with a live activity",
                UnableToDeletePackage: "Plan cannot be deleted because it is associated with an active account ",
                unactive: "Inactive",
                UnauthorizeEditContact: "Forbidden access to this resource to update. Please check your permissions",
                underTheUnit: "Under the unit",
                unexpired: "Unexpired",
                unitTime: "Time unit",
                unlockAccount: "Unlock account",
                unlockAccountConfirmation: 'Unlock "{account}"?',
                unlockAccountSuccess: "Unlock Account successfully ",
                unsuccessful: "Unsuccess",
                unsuccess: "Failure",
                update: "Update",
                updateAccountInfo: "Update account info",
                updateAdminAccount: "Update account info",
                updateApiConfig: "Update configuration",
                updateApiConfigSuccessful: "Upđate configuration successful",
                updateApp: "Update application info",
                updateAppSuccessful: "Application updated successful",
                updateCalendarLocationSuccessful: "Location updated successfully",
                updateContact: "Update contact",
                updateCustomerInfo: "Update customer info",
                updateCustomerInfoSuccessful: "Customer updated successful!",
                updateDate: "Date updated",
                updateEmailTemplateSuccessful: "Update email template successful",
                updateInfo: "Update info",
                updateMeetingParticipant: "Update meeting participant",
                updatePersonalInfo: "Update personal info",
                updateRegion: "Update Information",
                updateRegionSuccessful: "Region updated successfully",
                UpdateRoleInvalid: "Field role in invalid. Please use 'Customer', 'User' or 'View' role instead",
                updateSmartVoiceSuccessful: "Update SmartVoice Token successfully.",
                updateSubPlan: "Update package",
                updateSubPlanSuccessful: "Update package successful",
                UpdateSuccess: "The information was successfully updated",
                updateSuccessful: "Updated successful",
                upgradeConfirmCorrectInfo: "Please confirm the information above is correct",
                upgradeDurationExtension: "Extension duration",
                upgradeOption0: "Keep the current billing period",
                upgradeOption1: "Extend the current billing period",
                upgradeOption: "Change service option",
                upgradeService: "Change service",
                upgradeServiceSuccessful: "Changed service successful",
                upgradePlanDescription: "You can upgrade your service plan to increase storage capacity and manage more important records",
                Upload_failed: "Image upload failed",
                Upload_failed_code_exist: "Error: Code already exists",
                Upload_success: "Upload image successfully",
                UrlNotAllowed: "Url Not Allowed",
                useFullSystem: "Use system settings",
                username: "Username",
                usernameDescription: "Accept alphanumeric characters and underscores _",
                UsernameDuplicate: "The username  is taken. Try another",
                UsernameExist: "The username is taken. Try another",
                UsernameMaxLength: "Max username length is 32 characters",
                UsernameNotFound: "Username does not exist.",
                usernameOrEmail: "Account",
                UsernameRequired: "Username field  is required",
                UserNotFound: "Account is not found ",
                vatTax: "VAT tax",
                verificationEmailSent: "Verification email sent",
                verificationEmailSentSubtitle: "We have sent an email to {email}.\nPlease click the confirmation link in the email to complete verification and start using VNPT GoMeet.",
                version: "Version",
                view: "View",
                viewMeetingRecordedFile: "View recorded file",
                viewmore: "View more",
                viewOnly: "View only",
                viewStats: "View stats",
                viewDetails: "View details",
                viewTemplateAPIImportContact: "View user manual file",
                vinaphone: "Vinaphone",
                vt_ttp: "VT-TTP",
                vnptGroup: "VNPT Group",
                warningIdIconSub: "There is no face recognition image yet. Go to Contacts to update this person's face image!",
                WebhookConfigurationIsExisting: "Webhook configuration already exists for this account ",
                weeklyCalendar: "Weekly calendar",
                weeklyCalendarList: "Weekly calendar list",
                weeks: "Weeks",
                welcomeMsg: "Welcome to VNPT GoMeet",
                welcomeMsgSubtitle: "Hello! To get started with VNPT GoMeet we need a few details from you to create your free account.",
                welcomeToGoMeet: "Welcome to VNPT GoMeet",
                widgetDescription: " Widgets allow people to easily embed meeting room windows in their websites. Make it easier for everyone to use GoMeet",
                withdrawConsent: "Withdraw consent",
                withDrawCustomer: "Withdraw consent to process data",
                withDrawCustomerModalTitle: "Withdrawal of consent for data processing",
                withDrawCustomerModalBody: "Withdrawal of consent for data processing means you agree with VNPT to <b>lock your account and stop using VNPT GoMeet service</b>. For details, please refer to <b>article 5, section 4 </b> in the <b>Personal Data Protection Policy</b>.<br/><br/>Are you sure you want to withdraw consent for data processing?",
                withDrawCustomerSuccess: "Successfully withdrawn",
                withDrawCustomerConfirmation: 'Withdrawing consent will result in VNPT GoMeet ceasing the processing of personal data and locking the account for customer "{name}". Are you sure you want to perform this action?',
                workDepartment: "Department",
                workOrganization: "Organization",
                workOrganizationName: "Organization name",
                workTitle: "Work title",
                WrongPasswordAttempt: "Number of login attempts is range 1-100 times",
                wrongPasswordAttempt: "Wrong password attempt",
                years: "Years",
                yes: "Yes",
                yourStorageCapacity: "Storage capacity",
                yourPlanRemaining: "Your subscription plan has",
                countThisMonth: "Number of meetings held this month",
                limitReached: "reached the subscription plan limit",
                user: "User",
                trungtendanhba: "Duplicate contact name",
                trungsdt: "Duplicate phone number in contact list",
                trungemail: "Duplicate email in contact list",
                socuochopdatao: "Number of meetings created",
                socuochopdaketthuc: "Number of meetings completed",
                socuochopdahuy: "Number of meetings canceled",
                socuochopdaxoa: "Number of meetings deleted",
                datao: "Created",
                hoanthanh: "Completed",
                daxoa: "Canceled",
                deleted: "Deleted",
                dahuy: "Deleted",
                email: "Email",
                name: "Name",
                thoidiemtao: "Create time",
                goicuoc: "Package",
                songayconhieuluc: "Remain days",
                loaitaikhoan: "Account type",
                Id: "Id",
                sanluongkhachhangtu: "Number Customer output",
                songayconlai: "Remaining days",
                IdKH: "Customer ID",
                fileExcelNotData: "The file does not contain data",
                fileExcelFullName: "Full name must be at least 2 characters long",
                emailDuplicated: "Email already duplicated",
                fileExcelReadError: "Error reading file",
                userDuplicated: "Username already duplicated",
                fileExcelEmptyRowBetween: "The Excel file content is invalid!",
                person: "participant(s)",
                useFeature: "Active",
                alwaysEnabledByDefault: "Always use",
                featureConfiguration: "Feature configuration",
                faceIdConfig: "Face recognition",
                voiceTextConfig: "Summarize Meeting feature",
                generalInfo: "General Information",
                featureSettings: "Features config",
                storageType_Fix: "Default storage",
                storageType_Session: "Session",
                storageType_Meeting: "Concurrent Meetings",
                storage_Select_Sum: "Maximum storage capacity {capacity}, storage {days} days",
                storageTime: "Storage time (days)",
                activePackage: "Active",
                unactivePackage: "Unactive",
                storageCapacityNotAllowNull: "Capacity is  not allowed null",
                storageTimeNotAllowNull: "Time is not allowed null",
                outputStatistic: "Output Statistics",
                saleAreaShort: "Area",
                unitArea: "Department",
                unitDepart: "Unit, department",
                accountCreatedDate: "Account creation date",
                desc: "Sort (Descending)",
                numDuration: "Meeting Duration",
                usedStotage: "Storage Used",
                timeSumaration: "Meeting Summary Duration",
                record: "Record",
                aiGen: "AI generation",
                exportPDF: "Export PDF",
                day: "day",
                meetingStatis: "Meeting statistics",
                remainDays: "Remaining {date} days",
                sum: "Sum",
                timeMeeting: "Duration",
                storageMeeting: "Size",
                meetingTime: "Meeting Time",
                duration: "Duration",
                participantCount: "Number of Participants",
                package: "Package",
                packageDetail: "Package Details",
                allowedCapacity: "Allowed Capacity",
                recordingCapacity: "Recording Capacity",
                pleaseRenewPackage: "Please renew your subscription to continue hosting meetings and access all features.",
                pleaseRenewSoon: "Please renew your subscription soon to avoid meeting interruptions",
                youCanStillHostUpTo: "You can still host up to",
                pleaseUpgrade: "Please upgrade your subscription to continue hosting meetings and access all features",
                thankYouForBeingWithUs: "Thank you for being with us",
                summaryDuration: "Summary Duration",
                creatorId: "Creator Account Id",
                creatorAccount: "Creator Account",
                deletedAccount: "Delete Account",
                meetingStatistics: "Meeting Statistics",
                contactInfo: "Contact",
                totalActualDuration: "Total Th/lg",
                totalMeetingsRecorded: "Recording",
                totalRecordingSize: "Size",
                totalMeetingsSummary: "Total meeting summary ",
                recordingStats: "Recording & D/lg",
                plan: "Plan",
                outputStatisticTitle: "DETAILED STATISTICAL REPORT ON CUSTOMER {NAME}'S OUTPUT",
                outputStatisticDetail: "Output details",
                totalVoices: "Mic On",
                expiredPackage: "Expired",
                END: "End",
                PENDING: "Pending",
                INPROGRESS: "Inprogress",
                CANCEL: "Cancel",
                exporting: "Exporting",
                CH: "meetings",
                concurrent: "concurrent",
                timeCount: "time(s)",
                info: "Information",
                TL: "Dur",
                TG: "Times",
                TGia: "Join",
                perMeeting: "person/meeting",
                meetDay: "meeting/day",
                // joinCode: "Join code",
                // inputInfoMeeting: "JOIN MEETING",
                // joinCodePlaceHolder: "Enter join code",
                // joinMeetingDesc: "Enter the information to join your meeting!",
                addMaxMeetingParticipant: "Change number of participant",
                addMaxMeetingParticipantSuccess: "Change success",
                webinar_noti_private: "Select participants who are permitted to join in Regular Meeting mode. Participants in this mode can use their microphone, camera, and screen sharing, subject to the permissions set by the host.",
                webinar_noti_public: "Set a threshold for the number of participants allowed to join in Regular Meeting mode. These participants can use features such as microphone, camera, and screen sharing as configured by the host. All remaining participants will join in Webinar mode.",
                webinar_noti_2: "Those not on the list will join the meeting in Webinar mode.",
                webinar: "Webinar with mode meeting",
                on_time: "On",
                webinar_define: "The Webinar mode on VNPT GoMeet is a solution for organizing large-scale online seminars, training sessions, or virtual events over the Internet. This feature enables one or multiple presenters (Host/Co-host/Panelist) to share audio, video, screen content, and presentation slides with hundreds or even thousands of participants.",
                hh: "Hours",
                mm: "Minutes",
                numberOfNormalMeeting: "Number of participants in normal mode",
                maxParticipantMeetings: "Maximum: {number}",
                confirm: "Confirm",
                importParticipants: "Import participants",
                previewData: "Preview Data",
                notCorrect: "File contains no data or is in an invalid format",
                notCorrectFormat: "File does not match the required template. Please check again",
                errorReadFile: "An error occurred while reading the file",
                fileUpload: "Uploaded file contains {number} errors. Please check the data",
                rowFile: "Row",
                ColumnFile: "Column",
                importPhoneNotCorrect: "Invalid phone number",
                importEmailNotCorrect: "Invalid email format",
                importNotNull: "cannot be empty",
                importFormatCell: "Format",
                importNoteCorrect: "is invalid",
                importEmptyData: "Empty data",
                importaNotiCorrectData: "Please correct the erroneous data",
                importPass: "{number} duplicate row(s) not inserted",
                importSuccess: "Insert {number} participant(s) success",
                importMaximum: "The number of participants exceeds the limit({number})",
                amountOfWebinarParticipants: "Number of participants join with webinar mode",
                chooseSubscriptionNote: "When changing the service, the current service will be canceled.",
                vnptGomeet: " of <span style='color:#004f9e' >VNPT GoMeet</span>",
                privacyAgreementTitle: "Personal Data Protection Agreement",
                labelIAM: "I am:",
                labelMyEmail: "Email of mine:",
                privacyAgreementNote: "At&nbsp;<b>{date}</b>&nbsp;I have read and agreed with the personal data protection agreement issued by the Company",
                changeContentTitle: "Changes content:",
                versionInfo: "Version: {version} | Effective date: {date}",
                privacyPolicyTitle: "PERSONAL DATA PROTECTION POLICY FOR CUSTOMERS OF VNPT AI AND VNPT",
                ofProduct: "of product",
                btnAcceptAndContinue: "AGREE AND CONTINUE",
                btnLogoutOrReject: "LOGOUT / DISAGREE",
                managePrivacy: "Manage Policy",
                privacyID: "ID",
                privacyRefNo: "Reference Number",
                privacyVersion: "Version",
                privacyCreatedAt: "Created At",
                privacyUpdatedAt: "Updated At",
                privacyRequireVerify: "Require user verification before using the service",
                privacyContentLink: "Content Link",
                privacyLatestUpdate: "Latest content update",
                privacyCreateTitle: "Create Privacy Policy",
                privacyUpdateTitle: "Update Privacy Policy",
                privacyEffectiveDate: "Effective Date",
                privacyChangeContent: "Change Content",
                privacyCreateSuccess: "Create privacy policy successfully",
                privacyUpdateSuccess: "Update privacy policy successfully",
                policyScrollToRead: "Scroll down to continue",
                policyReadToConfirm: "Please read all content to confirm!",
                policyRequireAgree: "Please check the box to agree to the terms of service to continue.",
                policyRequireRead: "You must read all policy content!",
                unlockAccountCustomer: "Unlock Customer",
                recordingAudioOnly: "Audio only",
                recordingVideo: "Video recording",
                recordSound: "Audio Record",
                recordVideo: "Video Record",
                deletePersonalData: "Delete personal data",
                deletePersonalDataBody: "All your personal data will be permanently deleted from the system and cannot be recovered. Are you sure you want to continue?",
                deletePersonalDataSuccess: "Personal data deleted successfully",
                deletePersonalDataRequestTitle: "Personal data deletion request",
                deletePersonalDataDescription1: "All your account information and services will be deleted from the system when this request is processed.",
                deletePersonalDataDescription2: "Please read the details at:",
                deletePersonalDataPolicyArticle: "Article 5, section 5",
                deletePersonalDataDescription3: "in",
                deletePersonalDataDescription4: "of VNPT and fill in the required personal data deletion information below.",
                deletePersonalDataDescription5: "We will verify and process your request as soon as possible after receiving it.",
                requestLabel: "Request",
                requestPlaceholder: "Enter request details...",
                submitRequestSuccess: "Request submitted successfully!",
                submitRequest: "Sent",
                selecting: "Selecting ({count})",
                authenticationConfig: "Authentication config",
                connectionConfig: "Connection config (GRPC)",
                domainGrpc: "Domain (GRPC)",
                portGrpc: "Port (GRPC)",
                authorizationLabel: "Authorization",
                tokenIdLabel: "Token ID",
                tokenKeyLabel: "Token Key",
                passwordFormatConfig: "Password Format Configuration",
                securityLockoutConfig: "Security & Lockout Configuration",
                chooseWhiteboard: "Choose whiteboard",
                chooseWhiteboardDesc: "Select a whiteboard to use in the meeting",
                noWhiteboardAvailable: "No whiteboard available",
                noSelectWhiteboard: "No selection",
                noSelectWhiteboardDesc: "You can select again while the session is ongoing",
                createOtherWhiteboard: "Create another board",
                whiteboardInMeeting: "In use\nin meeting: {id}",
                createWhiteboardModalTitle: "Create whiteboard",
                editWhiteboardModalTitle: "Update whiteboard",
                whiteboardNameLabel: "Board name",
                whiteboardNamePlaceholder: "Enter whiteboard name...",
                rename: "Rename",
                createdWbText: "Created at: {time}",
                updatedWbText: "Updated: {time}",
                ai_quota: "AI Quota",
                purchaseAiQuotaTitle: "Purchase AI quota",
                aiQuotaType_NoUse: "Not used",
                aiQuotaType_Fixed: "Fixed",
                aiQuotaType_NoReset: "No Reset",
                aiQuotaType_Unlimited: "Unlimited",
                aiExtraDuration: "Extra duration",
                aiTotalDuration: "Total duration",
                currentExtraAiMinutes: "Current additional AI duration",
                purchaseExtraAiMinutes: "Purchase additional AI duration",
                totalAiDurationAfterPurchase: "Total AI duration after purchase",
                aiQuotaPeriodCycle: "According to package cycle",
                aiQuotaNoResetDescription: "Accumulate unused duration into the next cycle",
                aiQuotaUnlimitedDescription: "Unlimited",
                aiQuotaDurationMinutes: "Duration (Minutes)",
                minutesCapital: "Minutes",
                baseLimitLabel: "Base limit",
                whiteboardListTitle: "Whiteboard list",
                whiteboardNameColumn: "Whiteboard name",
                whiteboardCreatedColumn: "Created date",
                whiteboardModifiedColumn: "Modified date",
                whiteboardStatusColumn: "Status",
                whiteboardActionsColumn: "Actions",
                whiteboardInUse: "In use",
                whiteboardNotInUse: "Not in use",
                whiteboardUpdateBtn: "Update",
                whiteboardViewBtn: "View",
                whiteboardDeleteBtn: "Delete",
                whiteboardShareBtn: "Share",
                whiteboardDeleteConfirm: "Are you sure you want to permanently delete whiteboard \"{name}\"?",
                whiteboardDeleteSuccess: "Delete whiteboard successfully.",
                whiteboardShareModalTitle: "Share \"{name}\"",
                whiteboardShareAccessLabel: "General access",
                whiteboardShareAccessRestricted: "Restricted",
                whiteboardShareAccessPublic: "Anyone with the link",
                whiteboardShareAccessRestrictedDesc: "Only people with access can open with this link",
                whiteboardShareAccessPublicDesc: "Anyone with this link can access",
                whiteboardSharePermissionLabel: "Permission",
                whiteboardSharePermissionView: "Viewer",
                whiteboardSharePermissionEdit: "Editor",
                whiteboardSharePermissionViewDesc: "Anyone with an internet connection and this link can view",
                whiteboardSharePermissionEditDesc: "Anyone with an internet connection and this link can edit",
                whiteboardShareLinkLabel: "Link",
                whiteboardShareCopyBtn: "Copy",
                whiteboardShareCopied: "Link copied",
                whiteboardShareDoneBtn: "Đóng",
                startMeetingWithoutRecording: "Start without recording",
                startMeetingWithoutAI: "Start meeting without AI",
                startMeetingWithoutAISummary: "Start meeting without AI summary",
                startMeetingWithoutAILiveCaption: "Start meeting without AI captions",
                startMeetingWithoutRecordingAndAI: "Start meeting without recording and AI",
                changeQuantity: "Change quantity",
                maxCamEnabled: "Maximum enabled cameras",
                updateMaxCamSuccess: "Updated maximum enabled cameras successfully",
        },
};
